import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = [
    'ottoInput',
    'latInput',
    'ottoText',
    'ottoTextCorrected',
    'ottoInputCorrected',
    'alternateTextField',
    'latinInputCorrected',
    'latinValueStatus', // TODO: needs to be removed
    'toBeCheckedCheckBox',
    'misspelledCheckBox',
    'form',
    'contextViewBtn',
    'startQuoteBtn',
    'straightApostropheBtn',
    'endQuoteBtn',
    'addAlternateBtn',
    'formSubmitButton', // used in typing forms(edit partials) for ajax call to avoid sidebar items reload on item click
    'returnOrApproveModal', // TODO: this target is common for cropper controller & typing_form controller, find & use some js module approach for common attributes/functionalities
    'currentItemIndexContainer',
    'simpleStarIcon',
    'goldStarIcon',
    'bookmarkToggle',
    'markedAsContemporary',
    'markedAsOriginal',
    'markedAsVulgarCorrected',
    'markedAsOriginalCorrected',
    'letterMistakeCheckbox',
    'aWithCircumflex',
    'iWithCircumflex',
    'uWithCircumflex',
    'zwsBtn'
  ];

  initialize() {
    window['typing_form'] = this
    this.bookmarkToggleTarget.classList.remove('collapse');
    // to keep on toggle of bookmark
    if (isEnabledDisplayOnlyBookmarkedItems) {
      this.bookmarkToggleTarget.checked = true
    }
    this.typing_stage = this.element.dataset['typing']
    this.typing_for = this.element.dataset['objectType']
    this.current_item_id = this.element.dataset['typingFormItemId'] // id of currently active item
    // Changing tabs quickly with keys had a weird issue
    this.pausedChangingPreviewItem = false
    this.currentItemNotes = parseInt(this.element.dataset['currentItemNotesCount'])
    // this.isValueLatinPresent = JSON.parse(this.element.dataset['valueLatinPresent?']);
    this.validOttomanCharacters = JSON.parse(this.element.dataset['validOttomanCharacters']) // Space is optionally allowed in dictionary setting
    this.validOttomanCharactersForAlternates = JSON.parse(this.element.dataset['validOttomanCharactersForAlternates'] || '{}');
    this.validLatinCharacters = [' '].concat(JSON.parse(this.element.dataset['validLatinCharacters'])) // Adding <space> as an allowed character    
    this.otherWordIds = JSON.parse(this.element.dataset['otherWordIds'])
    this.otherWordsColors = JSON.parse(this.element.dataset['otherWordColors'])
    this.otherWordsColors.forEach((color, index) => {
      let fillStyle = BuildlqColors.hexToRGB(color)
      this.otherWordsColors[index] = fillStyle; //populating other word colors
    })
    this.areAllSpellingsSubmitted = this.element.dataset['allOttomanSpellingsSubmitted'] === 'true';
    this.isCurrentUserAdmin       = this.element.dataset['currentUserIsAdmin'] === 'true';
    this.requiredLanguageFlags    = JSON.parse(this.element.dataset.requiredLanguageFlagsForCombinedWord || '[]');
    this.ottomanLanguageFlags     = JSON.parse(this.element.dataset.ottomanLanguageFlags || '[]');
    if (this.element.dataset.objectType === 'combined_word') {
      this.syncManualLanguageIndicators();
    }

    // to show duplicate alternate fields(with comma separated values)if root leter toggle value is on initially when page loads
    this.showDuplicateFieldsForRootLeteredAlternates();

    // adding event listners to both  actual and duplicate alternate fields 
    $(document).on('focus', '.js-duplicate-field', this.showOriginalAndHideDuplicateAlternateIfRootLtr.bind(this));
    $(document).on('blur', '.js-otto-field-for-alternates', this.showDuplicateAndHideOriginalAlternateIfRootLtr.bind(this));

    this.setCursorFocus()
    setTimeout(() => {
      this.setCursorFocus()
    }, 50);
    setTimeout(() => {
      this.setCursorFocus()
    }, 100);
    this.isNotesModalOpen = false;

    // TODO: Move to connect
    let modalElement = document.getElementById("js-preview-modal");
    modalElement.addEventListener("hide.bs.modal", () => {
      preview_modal = undefined
    })


    // // TODO: move to latin history controller when controller created 
    // document.body.addEventListener('shown.bs.modal', function(event)  {
    //   if(event.target.classList.contains('js-latin-history-modal')){
    //     isLatinHistoryModalOpen = true;
    //   }
    // });

    // // TODO: move to latin history controller when controller created
    // document.body.addEventListener('hide.bs.modal', function(event)  {
    //   if(event.target.classList.contains('js-latin-history-modal')){
    //     isLatinHistoryModalOpen = false;
    //   }
    // });

   //hiding add alternative buttons of simple ottoman value if item is misspelled.
    if(this.hasMisspelledCheckBoxTarget && this.misspelledCheckBoxTarget.checked) {
      $('.js-add-alternative-btn.js-simple-add-alt-btn').addClass('d-none');
    }

    // removing this class so alt + enter hotkeys won't focus on hidden corrected ottoman value fields
    if(this.hasMisspelledCheckBoxTarget && !this.misspelledCheckBoxTarget.checked) {
      $('.js-corrected-ottoman-field').removeClass('js-text-field');
    }

    this.initializeDragAndDropInAlternativeEntries(".js-simple-sortable-values", ".js-simple-values-sortable-container");
    this.initializeDragAndDropInAlternativeEntries(".js-corrected-sortable-values", ".js-corrected-values-sortable-container");
    
    setTimeout(() => {
      this.updateComponentToggleVisibility();
      this.updateDerivedToggleVisibility();
      this.updateVerbToggleSeparatorVisibility();
      if (typeof typeo_form !== 'undefined') {
        typeo_form.scheduleMorphologicalToggleStatesUpdate();
      }
    }, 0);

    // Global method
    scrollToCurrentSelectedItem({ behavior: 'instant' });
    // this.handleMarkedAsPrimaryRadioBtnVisibility()

    this.handleVisibilityOfGenerateButton();
  }

  generateLatiVariantsIfSyllable(e) {
    const generateButton       = e.target;
    const typingFieldContainer = generateButton.closest('.js-typing-value-container');
    if (!typingFieldContainer) return;

    const primaryLatinField = typingFieldContainer.querySelector('.js-latin-text-field');
    if (!primaryLatinField) return;

    const syllable = primaryLatinField.value.trim();
    if (!syllable) return;

    const syllableVariants = this.generateSyllableVariants(syllable);
    if (syllableVariants.length <= 1) return;

    typing_prepopulation.deleteExistingAlternativeLatinFields(typingFieldContainer);

    syllableVariants.forEach((variant, index) => {
      if (index == 0) {
        primaryLatinField.value = variant;
        primaryLatinField.closest('.js-entries-input').querySelector('.js-otto-spelling-pronunciation-toggle').checked = true
      } else {
        this.populateAlternateLatinFieldWithSyllableVarient(typingFieldContainer, variant, index);
      }
    });

    this.handleVisibilityOfGenerateButton(e);
  }

  handleVisibilityOfGenerateButton(e) {
    function toggleGenerateBtnVisibilityBasedOnFields(container) {
      const latinFields = Array.from(container.querySelectorAll('.js-alternative-text-field'))
        .filter(field => field.offsetParent !== null && !field.classList.contains('d-none'));
      const generateBtn = container.querySelector('.js-syllable-variant-generator');
      if (generateBtn) {
        if (latinFields.length >= 1) {
          generateBtn.classList.add('d-none');
        } else {
          generateBtn.classList.remove('d-none');
        }
      }
    }

    if (e && e.target) {
      const relatedTextFieldsContainer = e.target.closest('.js-typing-value-container');
      if (relatedTextFieldsContainer) {
        toggleGenerateBtnVisibilityBasedOnFields(relatedTextFieldsContainer);
      }
    } else {
      $('.js-typing-value-container').each(function(_, el) {
        toggleGenerateBtnVisibilityBasedOnFields(el);
      });
    }
  }

  populateAlternateLatinFieldWithSyllableVarient(typingFieldContainer, variant, index) {
    typingFieldContainer.querySelector('.js-btn-add-alternate').click();

    let alternateTextFields         = typingFieldContainer.querySelectorAll('.js-alternative-text-field');
    let focusedAlternativeTextField = alternateTextFields[alternateTextFields.length - 1];
    const selectedTypingField       = focusedAlternativeTextField.closest('.js-entries-input');

    focusedAlternativeTextField.value = variant;
  }

  generateSyllableVariants(input) {
    // Split on hyphens for syllable groups
    const groups = input.split('-').map(group => group.split(/[.,\/]/).map(s => s.trim()).filter(Boolean));
    if (!groups.length || groups.some(g => !g.length)) return [];
    // Cartesian product
    const cartesian = (arr) => arr.reduce((a, b) => a.flatMap(d => b.map(e => d.concat([e]))), [[]]);
    return cartesian(groups).map(parts => parts.join(''));
  }

  // This method makes given divs moveable
  initializeDragAndDropInAlternativeEntries(moveable_class, containment_class) {
    const _this = this;

    $(moveable_class).each(function() {
      $(this).sortable({
        items: '.js-sortable-item',
        axis: 'y',
        handle: ".js-drag-handle",
        containment: $(this).closest(containment_class),
        tolerance: "pointer",
        cancel: '.js-not-sortable',              
        update: function(event, ui){
          _this.updateAddAltBtnsAndAssignedNumberFields(event, ui);
          // Update the primary Latin transcription after reordering of first latin field
          setTimeout(() => {
            if (!_this.isTypingLatinStage()) return;
            _this.setFirstFieldAsPrimary({ currentTarget: this });
          }, 0);

          typing_fields_arrow_connector.redrawFieldConnections();
          _this.updateDerivedToggleVisibility();
          _this.updateComponentToggleVisibility();
          _this.updateVerbToggleSeparatorVisibility();
        }
      });
    });
  }

  // This methods add red/blue divider between other values text box containers and updates red/blue dividers hidden field value
  addOrRemoveDividerBetweenOtherValues(e) {
    const otherValueContainer    = $(e.target).closest('.js-other-value-container')[0] || $(e.target).closest('.js-typing-value-container')[0];
    const dividerContainer       = otherValueContainer.querySelector(".js-dividers-container");
    const clickedDividerIcon     = e.target.closest("svg");
    const dividersIconsContainer = $(e.target).closest('.js-dividers-icons-container')[0];
    const redDividerIcon         = dividersIconsContainer.querySelector('.js-red-divider');
    const blueDividerIcon        = dividersIconsContainer.querySelector('.js-blue-divider');
    
    if (dividerContainer.classList.contains('danger-border-bottom') || dividerContainer.classList.contains('blue-border-bottom')) {
      this.removeDivider(otherValueContainer, dividerContainer, redDividerIcon, blueDividerIcon);
    } else {
      this.addDivider(otherValueContainer, dividerContainer, blueDividerIcon, redDividerIcon, clickedDividerIcon);
    }
  }

  removeDivider(otherValueContainer, dividerContainer, redDividerIcon, closeDividerIcon){
    const redDividerHiddenField  = otherValueContainer.querySelector('.js-has-red-divider');
    const blueDividerHiddenField = otherValueContainer.querySelector('.js-has-divider');
    
    // Remove divider  
    dividerContainer.classList.remove('danger-border-bottom', 'blue-border-bottom', 'mt-1', 'mb-2');
    
    // Revert close icon color
    closeDividerIcon.classList.remove('text-danger');
    closeDividerIcon.classList.add('light-blue-color');
    closeDividerIcon.classList.remove('cross-divider-icon');
    closeDividerIcon.classList.add('blue-divider-icon');
    
    // Revert hidden field values 
    redDividerHiddenField.value = 'false';
    blueDividerHiddenField.value = 'false';

    // Display both divider icons
    redDividerIcon.classList.remove('collapse');

    // Change the icon from x-circle to plus-circle
    closeDividerIcon.setAttribute('data-feather', 'plus-circle');
    feather.replace();
  }

  addDivider(otherValueContainer, dividerContainer, blueDividerIcon, redDividerIcon, clickedDividerIcon){
    const isRedDividerClicked = clickedDividerIcon.classList.contains('js-red-divider');
    
    let dividerField;
    let dividerColorClass;
    let crossIconColorClass;

    if (isRedDividerClicked) {
      dividerColorClass   = 'danger-border-bottom';
      dividerField        = otherValueContainer.querySelector('.js-has-red-divider');
      crossIconColorClass = 'text-danger';
    } else {
      dividerColorClass   = 'blue-border-bottom';
      dividerField        = otherValueContainer.querySelector('.js-has-divider');
      crossIconColorClass = 'light-blue-color';
    }

    // Add divider in required color  
    dividerContainer.classList.add(dividerColorClass, 'mt-1', 'mb-2');
    
    // Update cross icon style
    blueDividerIcon.classList.add(crossIconColorClass);
    blueDividerIcon.classList.remove('blue-divider-icon');
    blueDividerIcon.classList.add('cross-divider-icon');
    
    // Update hidden field value 
    dividerField.value = 'true';

    // Hide red divider icon
    redDividerIcon.classList.add('collapse');

    // Change the icon from plus-circle to x-circle
    blueDividerIcon.setAttribute('data-feather', 'x-circle');
    feather.replace();
  }

  // Helper method to update the identifiers and assigned numbers of alternative fields
  // Summary:
  // This method first determines the position of the field immediately above the moved field after it has been repositioned.
  // It then increments the assigned values and identifiers by 1 for all fields located below this above field.
  // Subsequently, it updates the assigned value and identifier of the moved field.
  // If the moved field is placed at the top, its new assigned value and identifier will be set to 1.
  updateAddAltBtnsAndAssignedNumberFields(e, ui) {
    const movedAltField               = ui.item;
    // Find the field with class 'nested-form-wrapper' above the moved field
    const aboveMovedTextField         = movedAltField.prevAll('.nested-form-wrapper').first();
    const aboveMovedTextFieldPosition = aboveMovedTextField.find('button[data-add-alternative-btn-identifier]').attr('data-add-alternative-btn-identifier');
    // update assigned value and position identifier of fields that are located below aboveMovedTextField
    this.updateAddAltBtnsAndAssignedValueFieldsAfterSelectedField(aboveMovedTextFieldPosition);
    // update assigned value and position identifier of moved field
    let movedAltFieldUpdatedPosition     = parseInt(aboveMovedTextFieldPosition) + 1;
    const movedAltFieldAddAlternativeBtn = movedAltField[0].querySelector('.js-add-alternative-btn');
    const movedAltFieldPrevPosition      = movedAltFieldAddAlternativeBtn.dataset.addAlternativeBtnIdentifier;
  // when field is moved to the top then movedAltFieldUpdatedPosition will be null
    if (isNaN(movedAltFieldUpdatedPosition)) {
      movedAltFieldUpdatedPosition = 0;
    }
    // This was added because, in case of an error, our setFirstFieldAsPrimary method was not being called.
    if (movedAltFieldAddAlternativeBtn && !isNaN(movedAltFieldUpdatedPosition)) {
      this.setAddAltBtnIdentifier(movedAltFieldAddAlternativeBtn, movedAltFieldUpdatedPosition);
    }
    this.updateAltEntryAssignedNumber(movedAltFieldPrevPosition, movedAltFieldUpdatedPosition);
  }

  // it is called when page is reloaded to set initial values(when no neither focus/blur event occured initially) of alternate text fields actual alternate fields/ duplicate alternate fields based on R.Ltr. Toggle saved value
  showDuplicateFieldsForRootLeteredAlternates() {
    const alternateInputFieldContainers = document.querySelectorAll('.entries-input');
    alternateInputFieldContainers.forEach(container => {
      const rootLetterToggle = container.querySelector('.js-root-letter-toggle');
      const relatedTextField = container.querySelector('.js-otto-field-for-alternates');
    
      // disabled (using 'false &&') to prevent execution as this functionality is not required currently.
      if (false && rootLetterToggle && relatedTextField) {
        if (rootLetterToggle.checked) {
          const event = { target: relatedTextField };
          this.showDuplicateAndHideOriginalAlternateIfRootLtr(event);
        } else {
          const relatedDuplicateField = container.querySelector('.js-duplicate-field');
          if (relatedDuplicateField) {
            const event = { target: relatedDuplicateField };
            this.showOriginalAndHideDuplicateAlternateIfRootLtr(event);
          }
        }
      }
    });
  }

  // this method adds comma between characters of passed text field value making sure that there are no more than one comma btw chars in case text already have comma separation
  getTextWithCommaBetweenCharacters(textFieldValue) {
    let textWithCommas = '';
    for (let i = 0; i < textFieldValue.length; i++) {
      textWithCommas += textFieldValue[i];
      if (textFieldValue[i] !== '،' && textFieldValue[i+1] !== '،' && i < textFieldValue.length - 1) {
        textWithCommas += '،';
      }
    }
    return textWithCommas;
  }

  // this method is called when cursor goes out of an duplicate alternate text field, this method checks if R.Ltr. toggle is on for an alternate text field, if it is on then it hides the duplicate field with comma separated value as cursor is not focused here and displays the actual alternate input field
  showOriginalAndHideDuplicateAlternateIfRootLtr(event) {
    const duplicateField = event.target;
    const container = duplicateField.closest('.entries-input');
    if (container) {
      const textField = container.querySelector('.js-otto-field-for-alternates');
      if (textField) {
        duplicateField.style.display = 'none';
        textField.style.display = 'block';
        textField.focus();
      }
    }
  }

  // this method is called when cursor goes in alternate text field, this method checks if R.Ltr. toggle is on for an alternate text field, if it is on then it displays a duplicate alternate field with comma separated values
  showDuplicateAndHideOriginalAlternateIfRootLtr(event) {
    const textField = event.target;
    const container = textField.closest('.entries-input'); // Find the closest specific container
    if (container) {
      const rootLetterToggle = container.querySelector('.js-root-letter-toggle');
      // disabled (using 'false &&') to prevent execution as this functionality is not required currently.
      if (false && rootLetterToggle && rootLetterToggle.checked) {
        const textWithCommas = this.getTextWithCommaBetweenCharacters(textField.value);
        const duplicateField = container.querySelector('.js-duplicate-field');
        if (duplicateField) {
          duplicateField.textContent = textWithCommas;
          // hiding the original alternate text input field and displaying duplicate field with comma separated values
          textField.style.display = 'none';
          duplicateField.style.display = 'block';
        }
      }
    }
  }

  handleRootLetterToggle(e){
    let relatedRootToggle = e.currentTarget.closest('.js-root-parent-container').querySelector('.marked-to-root-container')
    let relatedTextField  = e.currentTarget.closest('.entries-input').querySelector('.js-otto-field-for-alternates');
    if(e.currentTarget.checked) {
      // if Root Ltr. toggle is turned on then Root toggle will also be turned on and it(the simple Root) will be read only untill Root Ltr. is on
      relatedRootToggle.checked = true
      // this method is called here due to the requirement that harakat should be removed if root toggle is on and here Root Letter toggle is also making Root toggle on
      this.removeHarakatCharsFromTextFieldForRoot(e);
      // for read only when root toggle on
      relatedRootToggle.onclick = () => false;
      // if Root Ltr. toggle is on, then we will show the comma separated values
      if (relatedTextField) {
        const event = { target: relatedTextField }; // making this event because method showDuplicateAndHideOriginalAlternateIfRootLtr(e) takes events on text input fields
        this.showDuplicateAndHideOriginalAlternateIfRootLtr(event);
      }
    } else {
      // if Root Ltr. toggle is turned off then Root toggle will also be turned off and read only from Root will be removed
      relatedRootToggle.checked = false
      relatedRootToggle.onclick = () => true;
      // getting duplicate field (duplicate with comma separated values) to pass it as event to method showOriginalAndHideDuplicateAlternateIfRootLtr(e)
      let relatedDuplicateField = e.currentTarget.closest('.entries-input').querySelector('.js-duplicate-field');
      if (relatedDuplicateField) {
          const event = { target: relatedDuplicateField };
          this.showOriginalAndHideDuplicateAlternateIfRootLtr(event);
      }
      this.validOttomanCharactersForAlternates = JSON.parse(this.element.dataset['validOttomanCharactersForAlternates'])
    }
  }

  toggleBookmark(e){
    let url = null
    let url_type = null
    let data = {
      item_id: this.current_item_id,
      item_type: this.typing_for,
      typing: this.typing_stage
    };

    if (e.currentTarget.classList.contains('gold-star')) {
      this.goldStarIconTarget.classList.add('collapse')
      this.simpleStarIconTarget.classList.remove('collapse')
      document.querySelector('.js-selectable-entry.active').querySelector('.js-typing-list-item').dataset.starType = false
      
      url = '/page_set/bookmarks/' + this.current_item_id
      url_type = 'DELETE'
    } else {
      this.goldStarIconTarget.classList.remove('collapse')
      this.simpleStarIconTarget.classList.add('collapse')
      document.querySelector('.js-selectable-entry.active').querySelector('.js-typing-list-item').dataset.starType = true
      
      url = '/page_set/bookmarks'
      url_type = 'POST'
    }
    
    $.ajax({
      url: url ,
      type: url_type,
      data: data
    });
  }

  toggleBookmarkedItems(e){
    let allEntryItems = document.querySelectorAll('.js-selectable-entry')
    if (this.bookmarkToggleTarget.checked) {
      isEnabledDisplayOnlyBookmarkedItems = true
      allEntryItems.forEach((entry) => {
        if(entry.querySelector('.js-typing-list-item').dataset.starType == 'false'){
          // Temporarily doing this due to difference in staging vs local css difference
          entry.classList.remove('d-flex')
          entry.classList.add('hide_thumbnail')
        }
      })
    } else {
      isEnabledDisplayOnlyBookmarkedItems = false
      allEntryItems.forEach((entry) => {
        if(entry.classList.contains('hide_thumbnail')){
          entry.classList.add('d-flex')
          entry.classList.remove('hide_thumbnail')
        }
      })
    }
  }

  handleAlternateSpellingFieldsVisibility(alternateFieldsContainers, displayAlternateFields){
    alternateFieldsContainers.forEach(container => {
      if (displayAlternateFields) {
        container.classList.remove('d-none')
      } else {
        container.classList.add('d-none')
      }
    });
  }

  toggleAllPartToggles(partCheckBoxes, toBeChecked){
    partCheckBoxes.forEach(partCheckBox => {
      partCheckBox.checked = toBeChecked;
    });
  }

  hideSpellingLinkageCheckboxes() {
    const spellingLinkageCheckboxes = document.querySelectorAll('.js-spelling-linkage-checkbox-container');

    spellingLinkageCheckboxes.forEach((checkbox) => {
      checkbox.classList.add('d-none');
    });
  }

  unhideSpellingLinkageCheckboxes() {
    const spellingLinkageCheckboxes = document.querySelectorAll('.js-spelling-linkage-checkbox-container');

    spellingLinkageCheckboxes.forEach((checkbox) => {
      checkbox.classList.remove('d-none');
    });
  }

  handlePartAndCompoundFragmentExclusivity(e) {
    const currentToggle        = e.currentTarget;
    const typeoFieldsContainer = currentToggle.closest('#typeo-fields-container');
    if (!typeoFieldsContainer) return;

    const isPartToggle            = currentToggle.classList.contains('js-marked-as-part-visual-toggle');
    const isCompoundFragentToggle = currentToggle.classList.contains('js-marked-as-compound-fragment-visual-toggle');

    // Hidden fields
    const partToggleHiddenField       = typeoFieldsContainer.querySelector('.js-marked-as-part-fallback');
    const compoundFragmentHiddenField = typeoFieldsContainer.querySelector('.js-marked-as-compound-fragment-fallback');

    // All toggles for both sections (primary and corrected)
    const partToggles             = typeoFieldsContainer.querySelectorAll('.js-marked-as-part-visual-toggle');
    const compoundFragmentToggles = typeoFieldsContainer.querySelectorAll('.js-marked-as-compound-fragment-visual-toggle');

    // We only enforce exclusivity on "turn ON"
    if (isPartToggle && currentToggle.checked) {
      // Turn OFF all compound toggles
      compoundFragmentToggles.forEach(ct => { ct.checked = false; });
      if (compoundFragmentHiddenField) compoundFragmentHiddenField.value = '0';
    } else if (isCompoundFragentToggle && currentToggle.checked) {
      // Turn OFF all part toggles and run the part-off UI updates
      partToggles.forEach(pt => {
        if (pt.checked) {
          pt.checked = false;
          // Reusing existing handler so all related UI + hidden field updates happen
          this.handlePartToggleOn({ currentTarget: pt });
        }
      });
      // To ensure hidden reflects current state when we programmatically uncheck the other side
      if (compoundFragmentHiddenField) compoundFragmentHiddenField.value = '1';
    }
  }

  syncCompoundFragment(e) {
    const typeoFieldsContainer                = e.currentTarget.closest('#typeo-fields-container');
    const markedAsCompoundFragmentHiddenField = typeoFieldsContainer && typeoFieldsContainer.querySelector('.js-marked-as-compound-fragment-fallback');

    if (!markedAsCompoundFragmentHiddenField) return;

    const isChecked = e.currentTarget.checked;
    markedAsCompoundFragmentHiddenField.value = isChecked ? '1' : '0';

    // Keep primary/corrected C.Frg visuals in sync
    typeoFieldsContainer.querySelectorAll('.js-marked-as-compound-fragment-visual-toggle').forEach(toggle => {
      toggle.checked = isChecked;
    });
  }

  handlePartToggleOn(e) {
    const isChecked                            = e.currentTarget.checked
    // const misspelledFieldsContainer         = document.querySelector('#js-misspelled-fields-container')
    // const btnAddAlternate                   = document.querySelector('.js-alternative-fields')
    const spellingAlternateFieldsContainers    = document.querySelectorAll('.js-alternative-fields');
    const misspelledOptionsCheckboxes          = document.querySelector('.js-misspelled-checkboxes-container')

    const togglesContainerToHideIfMarkedAsPart = e.currentTarget.closest('.js-entries-input').querySelectorAll('.js-toogles-to-hide-if-marked-as-part')
    const partCheckBoxes                       = document.querySelectorAll('.marked-as-part-checkbox');

    const typeoFieldsContainer    = e.currentTarget.closest('#typeo-fields-container');
    const markedAsPartHiddenField = typeoFieldsContainer && typeoFieldsContainer.querySelector('.js-marked-as-part-fallback');

    const addAlternateBtns = document.querySelectorAll('.js-add-alternative-btn');

    // Keep primary/corrected Frg. visuals in sync
    partCheckBoxes.forEach(cb => { cb.checked = isChecked; });

    if (isChecked) {
      // misspelledFieldsContainer.classList.add('hide_thumbnail')
      // btnAddAlternate.classList.add('hide_thumbnail')
  
      if (markedAsPartHiddenField) markedAsPartHiddenField.value = '1';

      this.handleAlternateSpellingFieldsVisibility(spellingAlternateFieldsContainers, false)
      // this.misspelledCheckBoxTarget.checked = false
      this.misspelledCheckBoxTarget.setAttribute('disabled', true);
      misspelledOptionsCheckboxes.classList.add('hide_thumbnail');
      // togglesContainerToHideIfMarkedAsPart.classList.add('d-none');
      togglesContainerToHideIfMarkedAsPart.forEach(container => {
        container.classList.add('d-none'); // Add the 'd-none' class to hide the container
      });
      this.hideSpellingLinkageCheckboxes()
      typing_fields_arrow_connector.removeAllConnectionsRelatedToField(e);

      addAlternateBtns.forEach(btn => {
        btn.classList.add('d-none');
      })
    } else {
      // misspelledFieldsContainer.classList.remove('hide_thumbnail')
      // btnAddAlternate.classList.remove('hide_thumbnail')

      if (markedAsPartHiddenField) markedAsPartHiddenField.value = '0';
      this.handleAlternateSpellingFieldsVisibility(spellingAlternateFieldsContainers, true)     
      this.misspelledCheckBoxTarget.disabled = false;
      misspelledOptionsCheckboxes.classList.remove('hide_thumbnail');
      // togglesContainerToHideIfMarkedAsPart.classList.remove('d-none');
      togglesContainerToHideIfMarkedAsPart.forEach(container => {
        container.classList.remove('d-none'); // Add the 'd-none' class to hide the container
      });      
      this.unhideSpellingLinkageCheckboxes()
    }

    // Frg. hides alternate value cards below — re-run Root-below gating so Infl./Drvl. disable (Section 7).
    typeo_form?.scheduleMorphologicalToggleStatesUpdate();
  }

  // Handles validation and insertion for ZWS
  handleZwsInsertion(e) {
    const typingField = this.lastFocusedField;
    const cursorPos = this.getCursorPosition('\u200C', typingField.value);
    const nonConnectingChars = ['ا', 'آ', 'أ', 'إ', 'ء', 'د', 'ذ', 'ر', 'ز', 'ژ', 'و', 'ؤ', 'ە', 'ۀ', 'ة'];
    const value_ottoman = typingField.value; //Get the current value of the typing field
    const pos = cursorPos !== null ? cursorPos : typingField.selectionStart;  // Determine the cursor position, fallback to selectionStart if cursorPos is null
    const errorMsg = 'You cannot add a zero-width space at the beginning or end of a word, or immediately after the following characters: ' + nonConnectingChars.join(', ');  // Error message for insertion of ZWS at invalid position.
    // Validate: if value_ottoman starts or ends with a zero-width space (ZWS) and if ZWS appears immediately after a non-connecting character
    if (
      pos === 0 ||
      pos === value_ottoman.length ||
      (pos > 0 && nonConnectingChars.includes(value_ottoman[pos - 1]))
    ) {
      // showFlashMessage(errorMsg, 'error'); //As per requirement, we don't need to show error. // https://trello.com/c/YfE11Ohe/1897-typeo-auto-remove-zws-after-non-connecting-letters-dont-show-warning
      this.lastFocusedField.focus();
      return;
    }
    this.addCharacterWhereCursorPointing('\u200C');
  }

  addSpecialCharacterForTypingForm(e) {
    e.preventDefault();
    // TODO: use data-attribute to fetch value, instead of text within button
    if (e.currentTarget.innerText === 'ZWS') {
      this.handleZwsInsertion(e);
    } else {
      const character = e.currentTarget.getAttribute('data-mapped-value') || e.currentTarget.innerText;
      this.addCharacterWhereCursorPointing(character)
    }
  }

  getCursorPosition(currentCharacter, currentValue) {
    const cursorArray  = Array.from(currentValue); // Split by grapheme clusters
    const arrayLength  = cursorArray.length
    const previousChar = cursorArray[arrayLength - 1];

    const isPreviousCharacterHarakat = /[\u064B-\u0653]/.test(previousChar);

    let selectionStart = this.lastFocusedField.selectionStart;
    let selectionEnd   = this.lastFocusedField.selectionEnd;

    let cursorPosition = this.lastFocusedField.selectionStart;

    // if previous character is a Harkat and cursor is at the end of the word/spelling, then add 1 to current position of cursor to consider/add Harakat in the count of word letters
    if(isPreviousCharacterHarakat && selectionStart == selectionEnd){
      cursorPosition = cursorPosition + 1;
      this.lastFocusedField.selectionEnd = cursorPosition;
    }

    return cursorPosition;
  }

  addCharacterWhereCursorPointing(specialCharacter){
    const currentValue    = this.lastFocusedField.value;
    let cursorPosition    = this.getCursorPosition(specialCharacter, currentValue)
    let selectionEnd      = this.lastFocusedField.selectionEnd;
    let selectedCharacter = this.lastFocusedField.value.substring(this.lastFocusedField.selectionStart, this.lastFocusedField.selectionEnd);
    
    // To replace selected character with specialCharacter
    const newValue = currentValue.slice(0, cursorPosition) + specialCharacter + currentValue.slice(selectionEnd);
    this.lastFocusedField.value = newValue;
    this.lastFocusedField.setSelectionRange(cursorPosition + 1, cursorPosition + 1); // Move cursor after apostrophe
    this.lastFocusedField.focus();
    
    let event = new Event('input');
    this.lastFocusedField.dispatchEvent(event) // To call onchange callbacks
  }

  showItemOfWrittenIndex(e) {
    this.currentItemIndexContainerTarget.contentEditable = true;
    this.currentItemIndexContainerTarget.focus();
    this.currentItemIndexContainerTarget.innerText = '';
  }

  editToWrittenEntryItem(){
    let currentItemIndexContainer = this.currentItemIndexContainerTarget
    let allEntryItems = document.querySelectorAll('.js-selectable-entry')
    if (Number(currentItemIndexContainer.innerText) <= allEntryItems.length ) {
      allEntryItems[currentItemIndexContainer.innerText-1].click()
      currentItemIndexContainer.blur()
    } else {
      allEntryItems[allEntryItems.length - 1].click()
      currentItemIndexContainer.blur()
    }
    currentItemIndexContainer.contentEditable = false
  }

  setCursorFocus(){
    let entriesInputField;
    if(typing_form.isTypingLatinStage()) {
      entriesInputField = typing_form.latInputTarget;
      typing_form.lastFocusedField = typing_form.latInputTarget;
    } else {
      entriesInputField = typing_form.ottoInputTarget;
      typing_form.lastFocusedField = typing_form.ottoInputTarget;
    }

    // First new Alternate transcription button can be used to scroll, for a better UX
    entriesInputField.focus({ preventScroll: true });
    scrollIntoView(entriesInputField, {
      block: 'end', // To scroll only to show current typing element at end
      behavior: 'instant'
    })
  }

  removeOttomanSpellingAndItsLatinFields(e) {
    e.preventDefault();
    
    if (!this.isTypingLatinStage()) return;
    
    const ottomanSpellingContainer = e.currentTarget.closest('.js-typing-value-container');
    
    // Find all Latin text fields and mark them for destruction
    const latinTextFields = ottomanSpellingContainer.querySelectorAll('.js-text-field');
    
    latinTextFields.forEach(field => {
      const destroyField = field.closest('.nested-form-wrapper').querySelector('input.js-text-field');
      if (destroyField) {
        destroyField.value = '1';
      }

      field.closest('.nested-form-wrapper').style.display = 'none';
    });
    
    // Mark the Ottoman spelling for destruction
    const ottomanDestroyField = ottomanSpellingContainer.querySelector('input.js-ott-destroy-field');
    if (ottomanDestroyField) {
      ottomanDestroyField.value = '1';
    }

    ottomanSpellingContainer.style.display = 'none';
  }

  // Manually, addition of alternative entry works independent of this method.
  // This method clicks that button to add alternative entry
  addAlternativeEntryManually(){
    let selectedText = window.getSelection().toString();
    this.lastFocusedField.closest('.js-typing-value-container').querySelector('.js-btn-add-alternate').click()

    // setting spelling text field value as it will be needed when this spelling will become component
    typeo_form.previousSpellingValues.set(this.lastFocusedField.id, this.lastFocusedField.value);

    // After a short delay, focus on the newly added alternate field, set its value if text is selected,
    // filter the characters to ensure validity, and remove the temporary class used for identification.
    setTimeout(() => {
      const newAlternateField = document.querySelector('.js-new-added-alternate-field-container .js-text-field');
      if (newAlternateField) {
      newAlternateField.focus();
      this.lastFocusedField = newAlternateField;
      if (selectedText) newAlternateField.value = selectedText;
      this.filterValidCharacters({ currentTarget: newAlternateField });
      newAlternateField.closest('.js-new-added-alternate-field-container').classList.remove('js-new-added-alternate-field-container');
      }
    }, 0);
  }

  moveToNextTextField(){
    var textFields = document.querySelectorAll('.js-text-field');
    var nextIndex  = this.getNextFieldIndex(textFields);

    textFields[nextIndex].focus();
  }

  // copy and paste selected text to next transcription field
  copySelectedTextToNextTranscriptionField(selectedText){
    var textFields   = document.querySelectorAll('.js-latin-text-field');
    var nextIndex    = this.getNextFieldIndex(textFields);
    var nextElement  = textFields[nextIndex];

    // handled cases of empty selected value and last field 
    if (nextIndex == 0 || selectedText.length == 0) return;
    nextElement.value = selectedText;
    nextElement.focus();

    this.filterValidCharacters({ currentTarget: nextElement });
  }

  // Helper function to get the index of the next transcription field
  getNextFieldIndex(textFields) {
    var focusedElement = document.activeElement;
    var currentIndex   = Array.prototype.indexOf.call(textFields, focusedElement);
    
    return (currentIndex + 1) % textFields.length;
  }

  // Alternate entry is hid from view through nested-form library. However, need to set its _destroy flag (hidden field) to true for backend. Setting here
  removeAlternativeEntry(e) {
    let destroyFieldId = e.currentTarget.dataset.destroyFieldId;
    document.getElementById(destroyFieldId).value = true
  }

  // TODO: Update method name, handling multiple responsibilities.
  setFirstFieldAsPrimary(e) {
    const current_target     = e.currentTarget;
    const currentTargetValue = current_target.closest('.js-typing-value-container');
    const allFields          = currentTargetValue.querySelectorAll('.js-latin-entries-input');

    // Filter only visible and not destroyed
    const visibleFields = [];
    allFields.forEach(field => {
      const parentContainer = field.closest('.js-other-value-container');
      const isVisible       = !parentContainer?.classList.contains('d-none');
      if (isVisible) {
        visibleFields.push(field);
      }
    });

    // Unset all primary flags for all items in container
    allFields.forEach(field => {
      const isPrimaryInput = field.querySelector('.js-is-primary-hidden-field');
      if (isPrimaryInput) {
        isPrimaryInput.value = "0";
      }

      field.querySelector('.js-mispronounced-toggle-container').classList.remove('d-none');
      field.querySelector('.js-close-to-accurate-toggle-container').classList.remove('d-none');
      field.querySelector('.js-related-toggle-container').classList.remove('d-none');
      field.querySelector('.js-divergent-toggle-container').classList.remove('d-none');
      field.querySelector('.js-other_latin_values_dropdown-container').classList.add('d-none');
    });
    
    // Set the first valid item as primary
    const firstVisibleField = visibleFields[0];
    const isPrimaryInput    = firstVisibleField.querySelector('.js-is-primary-hidden-field');

    if (isPrimaryInput) {
      isPrimaryInput.value = "1";
      firstVisibleField.querySelector('.js-mispronounced-toggle-container').classList.add('d-none');
      firstVisibleField.querySelector('.js-close-to-accurate-toggle-container').classList.add('d-none');
      firstVisibleField.querySelector('.js-related-toggle-container').classList.add('d-none');
      firstVisibleField.querySelector('.js-divergent-toggle-container').classList.add('d-none');
      firstVisibleField.querySelector('.js-other_latin_values_dropdown-container').classList.remove('d-none');
    }
  }

  // Alternate entry is hid from view through nested-form library. However, need to reset its component flag. Setting here
  uncheckComponentToggleFromDeletedField(e) {
    const destroyBtn      = e.currentTarget;
    const componentToggle = destroyBtn.closest('.js-entries-input').querySelector('input.js-marked-as-component-toggle');

    if (componentToggle && componentToggle.checked) {
      componentToggle.click();
    }
  }

  setCurrentItemNotes(notes_count){
    this.currentItemNotes = notes_count
  }

  // This method sets the first corrected spelling as the primary corrected spelling when the misspelled toggle is turned on.
  clickMarkedAsPrimaryRadioBtnOfCorrectedOttoField() {
    const correctedSpellingContainer = $(".js-corrected-spellings-container");
    if (!correctedSpellingContainer[0]) return;

    const correctedSpellingRadioBtn  = correctedSpellingContainer[0].querySelector('.js-marked-as-primary-radio-btn');
    
    this.resetEntryWordSpellingsExistingLinkages(correctedSpellingContainer[0]);
    typeo_form.handleSpellingLinkagesMoleculeIcon(correctedSpellingContainer[0]);
    
    if (!correctedSpellingRadioBtn) return;
    correctedSpellingRadioBtn.click();
  }

  clickMarkedAsPrimaryRadioBtnOfPrimaryOttoField() {
    const primarySpellingContainer = $(".js-primary-spellings-container");
    if (!primarySpellingContainer[0]) return;
    
    const primarySpellingRadioBtn  = primarySpellingContainer[0].querySelector('.js-marked-as-primary-radio-btn');
    this.resetEntryWordSpellingsExistingLinkages(primarySpellingContainer[0]);
    typeo_form.handleSpellingLinkagesMoleculeIcon(primarySpellingContainer[0]);
    if (!primarySpellingRadioBtn) return;
    primarySpellingRadioBtn.click();
  }

  // In this method we are deleting all the corrected alternates from front end if misspelled toggle is turned Off
  removeCorrectedAlternatesIfPresent() {
    const alternateFieldContainers = document.querySelectorAll('.js-other-value-container');
    alternateFieldContainers.forEach(container => {
      const removeButton = container.querySelector('.js-remove-alternative-entry');

      if (removeButton) {
        removeButton.click();
      }
    });
  }

  // This method reassigns the primary status to first spelling and removes itself.
  removeOttomanSpelling(e) {
    e.preventDefault();
    
    const otherValueContainer = e.currentTarget.closest('.js-other-value-container');
    const isPrimary = otherValueContainer.querySelector('.js-marked-as-primary-radio-btn')?.checked;

    if (isPrimary) {
      const spellings = [...document.querySelectorAll('.js-entries-input')];
  
      let smallestOrderNumber = Infinity;
      let firstSpellingFeild = null;
      
      spellings.forEach(spellingItem => {
        const orderNumber = parseInt(spellingItem.querySelector('.js-otto-spelling-assigned-number')?.value, 10);

        // Check if the order number smaller than the current smallest
        if (orderNumber < smallestOrderNumber) {
          smallestOrderNumber = orderNumber;
          firstSpellingFeild = spellingItem;
        }
      });

      if (firstSpellingFeild) {
        const radioButton = firstSpellingFeild.querySelector('.js-marked-as-primary-radio-btn');
        if (radioButton) {
          radioButton.click();
        }
      }
    }
    
    const nestedFormElement = e.currentTarget.closest('[data-controller="nested-form"]');
    const nestedFormController = this.application.getControllerForElementAndIdentifier(nestedFormElement, "nested-form");
    nestedFormController.remove(e);
  }

  convertPrimaryAlternatesToCorrectedAlternates() {
    // here we are picking the div container for corrected alternate values
    const correctedAlternatesContainer = document.querySelector('.js-corrected-other-values-container');
    if (correctedAlternatesContainer) {
      // here we are picking all the alternate fields (currently primary's alternates)
      const alternateFieldContainers = document.querySelectorAll('.js-other-value-container');
      
      // here we are re-positioning all the primary's alternate fields from their primary container to corrected alternates container 
      alternateFieldContainers.forEach(alternateValueContainer => {
        correctedAlternatesContainer.appendChild(alternateValueContainer); // Move the element inside the target container
      });
    }

    // here we are updating the classes and the hidden field values of alternate fields to convert them from primary to corrected alternate
    const alternateFields = document.querySelectorAll('.js-alternate-ottoman-spelling-text-field');
    alternateFields.forEach(field => {
      field.classList.remove('js-simple-ottoman-alternative-value');
      field.classList.remove('for-corrected-value-false'); 

      field.classList.add('for-corrected-value-true');
      field.classList.add('js-corrected-ottoman-field');
      field.classList.add('js-corrected-ottoman-alternative-value');
      
      const alternateFieldcontainer = field.closest('.js-other-value-container');
      if (alternateFieldcontainer) {
        let hiddenFieldForIsCorrected = alternateFieldcontainer.querySelector('.js-is-corrected-ottoman-for-alternate-hidden-field');
        hiddenFieldForIsCorrected.value = true;
        // $(hiddenFieldForIsCorrected).trigger('change');
      }
    });
  }

  // When a word is marked as misspelled, certain toggles in primary fields are hidden. If the word is later unmarked as misspelled, the previously hidden toggles should be restored. This method handles these cases.
  handleVisibilityOfOttoSpellingToggles(isMisspelled){
    let primaryOttoFieldTogglesContainers = $('.js-primary-otto-field-toggles-container');
    let partToggleContainer               = $('.js-part-toggle-container-for-primary-spelling');

    if (isMisspelled){
      primaryOttoFieldTogglesContainers.each(function () {
        $(this).addClass('d-none');
      });
      partToggleContainer[0].classList.add('d-none');
    } else {
      primaryOttoFieldTogglesContainers.each(function () {
        $(this).removeClass('d-none');
      });
      partToggleContainer[0].classList.remove('d-none');
    }
  }

  // When the misspelled toggle is toggled on, we hide the radio buttons for all primary fields, so that only one of the corrected fields can be marked as primary.
  handleVisibilityOfMarkedAsPrimaryRadioBtnFromPrimaryFields(isMisspelled) {
    $(".js-marked-as-primary-radio-btn-container").each(function () {
      const isCorrectedOttomanField = this.closest('.js-entries-input')?.querySelector('.js-is-corrected-ottoman-hidden-field');
      const isCorrectedOttoman = isCorrectedOttomanField?.value;
      if (isMisspelled && isCorrectedOttoman === "false") {
        $(this).addClass("d-none");
      } else {
        $(this).removeClass("d-none");
      }
    });
  }

  uncheckTheCheckedComponentToggles(){
    const checkedComponentToggles = $('input.js-marked-as-component-toggle:checked');
    checkedComponentToggles.each(function() {
      $(this).click(); // to triggering any events bound to it
    }); 
  }

  hideSpellingLinkageCheckboxsFromAllMisspelledFields(){
    const allUncorrectedSpellings = [...document.querySelectorAll('.js-uncorrected-entry-input')];

    allUncorrectedSpellings.forEach((field) => {
      const checkboxContainer = field.querySelector('.js-spelling-linkage-checkbox');
      if (checkboxContainer) {
        checkboxContainer.classList.add('d-none');
      }
    });    
  }

  unhideSpellingLinkageCheckboxsFromAllMisspelledFields(){
    const allUncorrectedSpellings = [...document.querySelectorAll('.js-uncorrected-entry-input')];
    
    allUncorrectedSpellings.forEach((field) => {
      const checkboxContainer = field.querySelector('.js-spelling-linkage-checkbox');
      if (checkboxContainer) {
        checkboxContainer.classList.remove('d-none');
      }
    });    
  }

  // On selecting whether an item is misspelled, additional checkboxes are displayed and notes form is made visible.
  triggerMisspelled(e) {
    if (this.toBeCheckedCheckBoxTarget.checked && this.currentItemNotes > 0) {
      let msg = 'Please delete notes with conflicting labels before changing the label.'
      alert(msg)
      e.currentTarget.checked = false
      return false
    }

    // e.currentTarget.checked is the new value, and preventDefault reverts it
    if(!e.currentTarget.checked && this.currentItemNotes > 0){
      e.preventDefault();
      let msg = 'Because a note is labeled "Misspelled," it cannot be unchecked directly. To remove the check, you must delete all notes labeled as "Misspelled".'
      alert(msg)
      return false;
    }

    const misspelledOptionsContainer  = document.getElementById('misspelled-options')
    const misspelledOptionsCheckboxes = misspelledOptionsContainer.querySelectorAll('.js-misspelled-option-checkboxes');
    const misspelledFieldsContainer   = document.querySelector('#js-corrected-otto-fields-container')

    // handling cursor focus by hotkeys   
    let correctedOttomanSpellingFields = $('.js-corrected-ottoman-field');

    if (e.currentTarget.checked) {
      // this.showNotesWithAdditionalFlags({ created_on_type_o_misspelled: true })
      // Auto-check Letters When Misspelled is Toggled On
      this.letterMistakeCheckboxTarget.checked = true;
      misspelledOptionsContainer.classList.remove('d-none');
      misspelledFieldsContainer.classList.remove('d-none');
      //hiding add alternative button of simple ottoman value if item is misspelled.
      $('.js-add-alternative-btn.js-simple-add-alt-btn').addClass('d-none');
      $('.js-simple-alternate-and-combine-frg-btns-group').addClass('d-none');
      this.toBeCheckedCheckBoxTarget.checked = false
      correctedOttomanSpellingFields.addClass('js-text-field');
      // Replicate ottoman simple to corrected value automatically
      this.ottoInputCorrectedTarget.value = this.ottoInputTarget.value;
      this.handleVisibilityOfOttoSpellingToggles(true);
      this.handleVisibilityOfMarkedAsPrimaryRadioBtnFromPrimaryFields(true);
      this.uncheckTheCheckedComponentToggles();
      this.clickMarkedAsPrimaryRadioBtnOfCorrectedOttoField();
      this.hideSpellingLinkageCheckboxsFromAllMisspelledFields();
      typeo_form?.scheduleMorphologicalToggleStatesUpdate({ lane: 'corrected' });
      // this.convertPrimaryAlternatesToCorrectedAlternates()
      if (typeof typeo_form !== 'undefined') {
        typeo_form.syncActiveSpellingWordTogglesVisibility(true);
      }
    } else {
      misspelledOptionsContainer.classList.add('d-none');
      misspelledFieldsContainer.classList.add('d-none')
      //adding add alternative button of simple ottoman value if item is not misspelled.
      $('.js-add-alternative-btn.js-simple-add-alt-btn').removeClass('d-none');
      $('.js-simple-alternate-and-combine-frg-btns-group').removeClass('d-none');    
      correctedOttomanSpellingFields.removeClass('js-text-field');
      // Uncheck all checkboxes inside the misspelled-options container
      misspelledOptionsCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      this.handleVisibilityOfOttoSpellingToggles(false);
      this.handleVisibilityOfMarkedAsPrimaryRadioBtnFromPrimaryFields(false);
      this.clickMarkedAsPrimaryRadioBtnOfPrimaryOttoField();
      this.unhideSpellingLinkageCheckboxsFromAllMisspelledFields();
      // this.removeCorrectedAlternatesIfPresent()
      if (typeof typeo_form !== 'undefined') {
        typeo_form.syncActiveSpellingWordTogglesVisibility(false);
      }
    }
  }

  // On selecting whether an item is misspelled, additional checkboxes are displayed and notes form is made visible.
  triggerTypeLMisspelled(e) {
    const misspelledOptions = document.getElementById('misspelled-options')
    const misspelledOptionsCheckboxes = misspelledOptions.querySelectorAll('.js-misspelled-option-checkboxes');

    if (e.currentTarget.checked) {
      // this.showNotesWithAdditionalFlags({ created_on_type_l_misspelled: true })
      // TODO: Fix: this.toBeCheckedCheckBoxTarget.checked = false
      misspelledOptions.classList.remove('d-none');
    } else {
      misspelledOptions.classList.add('d-none');
      misspelledOptionsCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
    }
  }

  showNotesWithAdditionalFlags({ created_on_type_o_to_be_checked = false, created_on_type_o_misspelled = false, created_on_type_l_to_be_checked = false, created_on_type_l_misspelled = false } ){
    let stagesElement = document.querySelector('.js-stages-controller');
    if(stagesElement){
      let stagesController = this.application.getControllerForElementAndIdentifier(
        stagesElement, "stages"
      );

      stagesController.showNotes({ created_on_type_o_to_be_checked: created_on_type_o_to_be_checked, created_on_type_o_misspelled: created_on_type_o_misspelled, created_on_type_l_to_be_checked: created_on_type_l_to_be_checked, created_on_type_l_misspelled: created_on_type_l_misspelled } )
    }
  }

  triggerToBeChecked(e) {
    if (this.typing_for != 'combined_word') {
      if (this.misspelledCheckBoxTarget.checked && this.currentItemNotes > 0) {
        let msg = 'Please delete notes with conflicting labels before changing the label.'
        alert(msg)
        e.currentTarget.checked = false
        return false
      }
    }

    if(!e.currentTarget.checked && this.currentItemNotes > 0){
      e.preventDefault();
      let msg = 'Because a note is labeled "Checked," it cannot be unchecked directly. To remove the check, you must delete all notes labeled as "Checked"'
      alert(msg)
      return false;
    }

    // If to be checked is selected, then system open notes automatically for ther user to create a new note
    if (this.typing_for != 'combined_word') {
      const misspelledOptionsContainer = document.getElementById('misspelled-options')
      const misspelledOptionsCheckboxes = misspelledOptionsContainer.querySelectorAll('.js-misspelled-option-checkboxes');
      let misspelledFieldsContainer = document.getElementById('js-corrected-otto-fields-container')

      if (e.currentTarget.checked) {
        // this.showNotesWithAdditionalFlags({ created_on_type_o_to_be_checked: true });
        this.misspelledCheckBoxTarget.checked = false

        misspelledOptionsContainer.classList.add('d-none');
        misspelledFieldsContainer.classList.add('d-none')
        // Uncheck all checkboxes inside the misspelled-options container
        misspelledOptionsCheckboxes.forEach(checkbox => {
          checkbox.checked = false;
        });

      }
    }
  }

  triggerTypelToBeChecked(e){
    const misspelledOptions = document.getElementById('misspelled-options')
    if (e.currentTarget.checked) {
      // this.showNotesWithAdditionalFlags({ created_on_type_l_to_be_checked: true });
      // TODO: Wrong implementation. Fix. misspelledOptions.classList.add('d-none')
      // this.misspelledCheckBoxTarget.checked = false
    }
  }

  // getFontSize(fontSizePercent) {
  //   // type-field is the common class used for typing, and it is setting the height of field
  //   const maxFontSize = document.getElementsByClassName('type-field')[0].clientHeight * 1.15;
  //   return maxFontSize * fontSizePercent / 100;
  // }

  setFocusedField(e){
    this.lastFocusedField = e.currentTarget;
  }

  // TODO: fetch harakat characters from rails because we have a constant in rails side too
  // this method removes the harakats from the text in the text field when root toggle is toggled on/off
  removeHarakatCharsFromTextFieldForRoot(e) {
    // early return because this functionality is not required anymore, but the code is kept in case if it is needed again in future.
    // early return reason -> https://trello.com/c/N0plbAvz/1473-remove-restriction-on-alternate-values-for-harakat
    return
    const rootToggle = e.currentTarget;
    const textField = rootToggle.closest('.entries-input').querySelector('.js-otto-field-for-alternates');
    if (false && textField) {
      let textValue = textField.value;
      const harakatChars = ['َ', 'ِ', 'ٰ', 'ٖ', 'ُ', 'ٌ', 'ْ', 'ّ', 'ً', 'ٍ'];
      const regex = new RegExp(harakatChars.map(char => '\\' + char).join('|'), 'g');
      textValue = textValue.replace(regex, '');
      textField.value = textValue;
    }
  }

  // TODO: fetch harakat characters from rails because we have a constant in rails side too
  filterValidCharacters(e) {
    let str = e.currentTarget.value || '';
    let savedStr = str;
    let savedCursorPosition = e.currentTarget.selectionStart;
    str = this.removeConsecutiveSpaces(str)
    // we dont allow this specific combination in type-l
    str = str.replace('ھ ', 'ھ')
    str = str.replace('ھ\u200C', 'ھ')
    str = str.replace('ه\u200C', 'ه') // Connector Haa
    str = str.replace('ە\u200C', 'ە') // Non-Connector Haa
    let stringCharacters = str.split('')
    
    let allowedChars = []
    if (e.currentTarget.classList.contains('js-otto-field-for-alternates')){
      if (e.currentTarget.parentElement.querySelector('.js-root-letter-toggle')?.checked) {
        allowedChars = ['ء', 'ب', 'ت', 'ث', 'ج', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ك', 'ل', 'م', 'ن', 'و', 'ه', 'ی'];
      } else if (false && e.currentTarget.parentElement.querySelector('.js-root-toggle-typeo-alternates').checked) {
        // this else if is not required anymore the code is kept in case if it is needed again in future // https://trello.com/c/N0plbAvz/1473-remove-restriction-on-alternate-values-for-harakat
        const harakatChars = ['َ', 'ِ', 'ٰ', 'ٖ', 'ُ', 'ٌ', 'ْ', 'ّ', 'ً', 'ٍ'];
        let allowedCharsForRoot = this.validOttomanCharactersForAlternates;
        allowedChars = allowedCharsForRoot.filter(char => !harakatChars.includes(char));
      } else {
        allowedChars = this.validOttomanCharactersForAlternates
      }
    } else if (e.currentTarget.classList.contains('js-otto-field')) {
      allowedChars = this.validOttomanCharacters
    } else{
      allowedChars = this.validLatinCharacters
    }

    let validStr   = stringCharacters.filter((char) => allowedChars.includes(char)).join('');
    e.currentTarget.value = validStr;
    
    if(savedStr !== validStr){
      e.currentTarget.setSelectionRange(savedCursorPosition - 1, savedCursorPosition - 1); // Setting cursor to current position after setting filtered value
      e.currentTarget.focus()
    }
    
    // if(savedStr != str){ // it means words are filtered
    //   savedCursorPosition--;
    // }
    // // Setting placement of cursor
    // e.currentTarget.setSelectionRange(savedCursorPosition, savedCursorPosition); // Move cursor after apostrophe

    let wrongChars = stringCharacters.filter((char) => !allowedChars.includes(char));
    if(wrongChars.length > 0){
      // this.addFlashMessage(`Invalid character(s) [${wrongChars}] entered.`)
    }
  }

  // Remove consecutive space or zero with space, keeps 1
  removeConsecutiveSpaces(str) {
    let pattern = /( |\u200C)+/g; // Space and zero widht character. we keep one of these characters, if they appear consecutive
    let cleanedString = str.replace(pattern, (match, group) => group[0]);
    return cleanedString;
  }

  moveToPrevEntry(e){
    typing_form.submit(e, "prev");
  }

  moveToNextEntry(e){
    typing_form.submit(e, "next");
  }

  makeClickedItemActive(e) {
    $(".list-group-item").removeClass("active").removeClass("js-current-selected-item"); // Remove active and js-current-selected-item classes from all list items
    var closestAnchor = $(e.currentTarget).closest('a.list-group-item');  // Find the closest ancestor anchor tag (if any)
    if (closestAnchor.length > 0) { // Add active and js-current-selected-item classes to the closest anchor, js-current-selected-item for scrolling 
      closestAnchor.addClass("active js-current-selected-item");
    }
  }

  makePassedItemActive(itemId){
    $(".list-group-item").removeClass("active").removeClass("js-current-selected-item"); // Remove active and js-current-selected-item classes from all list items
    $(`#${itemId}`).addClass("active js-current-selected-item");
  }

  changeIconToSubmitted(itemId) {
    // getting the div containing icon
    const iconContainer = $(`#${itemId} .js-item-submission-status-icon-container`);
    if(iconContainer.length > 0){
      const icon = iconContainer.find('svg.feather.feather-edit-3');
      if(icon.length > 0){
        icon.replaceWith(feather.icons['check'].toSvg());
        // as the svg icon is replaced with updated icon, getting new svg icon to add classes to it
        const newIcon = iconContainer.find('svg.feather.feather-check');
        newIcon.addClass("ms-3 d-inline-block rounded-circle shadow-sm bg-success border border-2");
      }
    }
  }

  // if against item/image ottoman/latin value is present/exists then this method marks it green
  makePassedItemSubmitted(itemId){
    $(`#${itemId}`).removeClass("list-item-entry");
    $(`#${itemId}`).addClass("submitted-list-item-entry");
    this.changeIconToSubmitted(itemId);      
  }

  changeIconToNonSubmitted(itemId) {
    // getting the div containing icon
    const iconContainer = $(`#${itemId} .js-item-submission-status-icon-container`);
    if (iconContainer.length > 0) {
      const icon = iconContainer.find('svg.feather.feather-check');
      if (icon.length > 0) {
        icon.replaceWith(feather.icons['edit-3'].toSvg());
         // as the svg icon is replaced with updated icon, getting new svg icon to add classes to it
        const newIcon = iconContainer.find('svg.feather.feather-edit-3');
        newIcon.addClass("ms-3 d-inline-block shadow-sm");
      }
    }
  }

  // if against item/image ottoman/latin value is NOT present/exists then this method marks it non-green
  makePassedItemNonSubmitted(itemId){
    $(`#${itemId}`).removeClass("submitted-list-item-entry");
    $(`#${itemId}`).addClass("list-item-entry");
    this.changeIconToNonSubmitted(itemId);
  }

  showTogglesSelectionErrorIfRequired() {
    if (this.isTypingOttomanStage() && this.typing_for != 'combined_word') {
      const misspelledToggle  = document.getElementById('chk-to-be-misspelled');
      const textFieldsContainer = misspelledToggle.checked
          ? document.querySelector('#js-corrected-otto-fields-container')
          : document.querySelector('#js-primary-otto-fields-container');

      let showError = false;
      textFieldsContainer.querySelectorAll('.js-entries-input').forEach(entryInput => {
        if (showError) return; // Skip the further iterations if error case already identified

        let currentWordSpellingsLinkingtoggles = entryInput.querySelectorAll('.js-current-word-spellings-relationship-toggle');
        let entryWordSpellingsLinkingtoggles = entryInput.querySelectorAll('.js-entry-word-spellings-relationship-toggle');
        let isAnyCurrentWordToggleOn = true;
        let isAnyEntryWordToggleOn = true;
        
        // check if any current word linking toggle is selected 
        if (currentWordSpellingsLinkingtoggles.length > 0) {
          isAnyCurrentWordToggleOn = Array.from(currentWordSpellingsLinkingtoggles).some(toggle => toggle.checked);
        }

        // check toggles selection of only 'primary' spelling/entry spelling linking 
        if(entryInput.querySelector('.js-primary-entry-linkage')){
          isAnyEntryWordToggleOn = Array.from(entryWordSpellingsLinkingtoggles).some(toggle => toggle.checked);
        }

        // show error in case current spelling all toggles or entry word spelling all toggles are unchecked
        if (!(isAnyCurrentWordToggleOn && isAnyEntryWordToggleOn)) {
          showError = true;
        }
      });

      if (showError) {
          // showFlashMessage('At least one tag must be selected for each value.', 'alert');
          // return true;
      }
    }

    return false;
  }

  showMisspelledErrorIfRequired(){
    if (this.isTypingOttomanStage() && this.typing_for != 'combined_word' && this.misspelledCheckedWithNoOptions()){
      showFlashMessage('The item has been identified as <b>Misspelled</b>. To proceed, kindly review and select one of the following options: <b>Letters, Harakat or Complicated</b>', 'alert')
      return true;
    } else {
        return false;
    }
  }

  showUnknownToggleErrorIfRequired() {
    const toggles = document.querySelectorAll(".js-marked-as-unknown-toggle");  
    let hasShownError = false;

    toggles.forEach((toggle) => {
      if (hasShownError) return;

      if (toggle.checked) {
        const spellingField = this.currentTypingFieldContainer(toggle)
        const spellingNotesModal = spellingField.querySelector(".js-spelling-notes-modal"); 
        const notesField = spellingNotesModal.querySelector(".js-spelling-note-feild");

        if (!notesField || notesField.value.trim() === "") {
          showFlashMessage(
            "You must enter a note before proceeding because you activated the question mark toggle for a value.",
            "alert"
          );
          hasShownError = true;
        }
      }
    });
    return hasShownError;
  }

  showMissingPrimarySpellingErrorIfRequired() {
    const misspelledCheckBox = this.typing_for !== 'combined_word' ? this.misspelledCheckBoxTarget : null;

    let $checkedRadio;

    if (misspelledCheckBox && misspelledCheckBox.checked) {
      // Misspelled checked: only check in corrected and its alternate fields
      $checkedRadio = $('.js-corrected-entries-input .js-marked-as-primary-radio-btn:checked');
    } else {
      // Misspelled not checked: only check in primary and its alternate fields
      $checkedRadio = $('.js-uncorrected-entry-input .js-marked-as-primary-radio-btn:checked');
    }

    if ($checkedRadio.length === 0) {
      showFlashMessage('Please mark one spelling as primary before submitting.', 'error');
      return true;
    }

    return false;
  }

  moveToClickedItem(e){
    if (this.showMisspelledErrorIfRequired()){
      e.preventDefault(); // to prevent form submission // to prevent moving to next item and making it active in typing sidebar list 
      return;
    }
    // The code has been commented out as it is temporarily not required.
    // if (this.showTogglesSelectionErrorIfRequired()){
    //   e.preventDefault(); // to prevent form submission // to prevent moving to next item and making it active in typing sidebar list 
    //   return;
    // }

    // The code has been commented out as it is temporarily not required.
    // if (this.showUnknownToggleErrorIfRequired()){
    //   e.preventDefault(); // to prevent form submission // to prevent moving to next item  
    //   return;
    // }

    // Temporarily disabled: incomplete compound-component validation now runs during Type-O page set submission.
    // Kept so this entry-time check can be re-enabled later if needed.
    // if (this.isTypingOttomanStage() && (this.isCurrentUserAdmin || this.areAllSpellingsSubmitted) && typeo_form.showComponentTogglesSelectionErrorIfRequired()){
    //   e.preventDefault(); // to prevent form submission // to prevent moving to next item and making it active in typing sidebar list 
    //   return;
    // }

    if (this.isTypingOttomanStage() && typeo_form.showFragmentTypeTogglesSelectionErrorIfRequired()){
      e.preventDefault();
      return;
    }

    this.makeClickedItemActive(e);
    let itemId   = e.currentTarget.dataset.itemId;
    let itemType = e.currentTarget.dataset.itemType;
    typing_form.submit(e, null, itemId, itemType);
  }

  submit(e, moveDirection, itemId = null, itemType = null) {
    e.preventDefault();
    e.stopPropagation();

    if (this.showMisspelledErrorIfRequired()){
      return;
    }

    // The code has been commented out as it is temporarily not required.
    // if (this.showTogglesSelectionErrorIfRequired()){
    //   return;
    // }

    if (this.isTypingOttomanStage() && this.showMissingPrimarySpellingErrorIfRequired()){
      e.preventDefault();
      return;
    }

    // Temporarily disabled: incomplete compound-component validation now runs during Type-O page set submission.
    // Kept so this entry-time check can be re-enabled later if needed.
    // if (this.isTypingOttomanStage() && (this.isCurrentUserAdmin || this.areAllSpellingsSubmitted) && typeo_form.showComponentTogglesSelectionErrorIfRequired()){
    //   return;
    // }

    if (this.isTypingOttomanStage() && typeo_form.showFragmentTypeTogglesSelectionErrorIfRequired()){
      return;
    }

    if (typel_items) {
      typel_items.applyLatinFieldToggleRules();
    }

    let formElement = typing_form.formTarget;
    if (moveDirection == "prev") {
      let inp = document.createElement('input')
      inp.type = 'hidden'
      inp.name = 'redirect_prev'
      inp.value = 'true'
      formElement.appendChild(inp)
    }

    if (moveDirection == "next") {
      let inp = document.createElement('input')
      inp.type = 'hidden'
      inp.name = 'redirect_next'
      inp.value = 'true'
      formElement.appendChild(inp)
    }

    // when item is clicked from sidebar list
    if (itemId && itemType) {
      // Item id
      let inp = document.createElement('input')
      inp.type = 'hidden'
      inp.name = 'item_id'
      inp.value = itemId
      formElement.appendChild(inp)
      // Item Type 
      let inp2 = document.createElement('input')
      inp2.type = 'hidden'
      inp2.name = 'item_type'
      inp2.value = itemType
      formElement.appendChild(inp2)
    }

    let bookMarkTogglerInput = document.createElement('input')
    bookMarkTogglerInput.type = 'hidden'
    bookMarkTogglerInput.name = 'showOnlyBookmarkedItems'
    bookMarkTogglerInput.value = isEnabledDisplayOnlyBookmarkedItems
    formElement.appendChild(bookMarkTogglerInput)

    //formElement.submit() // here instead of formElement.submit() we are clicking Save submit button to avoid list elements reload(which slows down the page) & to make ajax call work instead. 
    if (this.formSubmitButtonTarget) {
      this.formSubmitButtonTarget.click();
    }
  }

  isTypingLatinStage(){
    return this.typing_stage == 'type_l'
  }

  isTypingOttomanStage(){
    return this.typing_stage == 'type_o'
  }

  isNavigateToPreviousItemShortcut(eventObject) {
    // Ctrl/Cmd + Enter moves to the previous item (exclude Alt/Shift variants).
    const enter = 13
    return (
      (eventObject.ctrlKey || eventObject.metaKey) &&
      !eventObject.altKey &&
      !eventObject.shiftKey &&
      eventObject.keyCode === enter
    )
  }

  // model key to add params according to back-end model
  modelKey(){
    let key = '';

    if (this.typing_for == 'entry'){
      key = 'entry'
    } else if (this.typing_for == 'subentry'){
      key = 'subentry'
    } else if (this.typing_for == 'other'){
      key = 'other_word'
    }
    return key;
  }

  focusToAlternateTranscription(e) {
    let newAlternateFieldContainer = document.querySelector('.js-new-added-alternate-field-container');
    if (newAlternateFieldContainer) {
      let inputField = newAlternateFieldContainer.querySelector('input');
      if (inputField) {
        inputField.focus();
        this.lastFocusedField = inputField;
      }
    }

    e.currentTarget.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
    typeo_form.setLanguageTogglesOfNewAddedField(newAlternateFieldContainer);

    // removing the class here so that when next time new alternate field is created, it should be available only on that newest alternate field 
    newAlternateFieldContainer.classList.remove('js-new-added-alternate-field-container');
  }

  addAppostrphe(e){
    // TODO: Dont directly use from buttons display html. Data attributes can be used for this
    let apostrophe = e.srcElement.innerHTML;
    const cursorPosition = this.lastFocusedField.selectionStart;
    const currentValue = this.lastFocusedField.value;
    
    const newValue =
      currentValue.substring(0, cursorPosition) +
      apostrophe +
      currentValue.substring(cursorPosition);
    
    this.lastFocusedField.value = newValue;
    this.lastFocusedField.setSelectionRange(cursorPosition + 1, cursorPosition + 1); // Move cursor after apostrophe
    this.lastFocusedField.focus();
  }

  clearOttomanField(e){
    if (e.currentTarget.classList.contains('js-simple-ottoman-field')) {
      this.ottoInputTarget.value = ''
    } else {
      this.ottoInputCorrectedTarget.value = ''
    }
  }

  hotKeys(e) {
    if (e.keyCode == 13 && isLatinHistoryModalOpen) {
      e.preventDefault()
    }

    if(this.isNotesModalOpen || context_modal || preview_modal || submit_page_set_modal || pageset_approve_or_return_modal || isLatinHistoryModalOpen){
      return true;
    }

    const eventObject = window.event ? event : e
    const enter       = 13
    const up          = 38
    const down        = 40
    const pgUp        = 33
    const pgDown      = 34
    const alt         = 18
    const ctrl        = 17
    const one         = 49
    const two         = 50
    const three       = 51
    const four        = 52
    const five        = 53
    const six         = 54    
    const left        = 37
    const right       = 39
    const c           = 67    
    const m           = 77
    const s           = 83
    const space       = 32
   
    const capturedKeys = [enter, up, down, pgUp, pgDown, alt, one, two, three, four, five, six, left, right, ctrl, c, m, s, space]

    if (eventObject.keyCode == enter && isLatinHistoryModalOpen) {
      e.preventDefault()
    }
    
    // Special handling for double quote key (") which may have different keyCodes on different keyboards
    const doubleQuoteKey = eventObject.key === '"';
    
    if (eventObject.keyCode === space && !eventObject.shiftKey && !eventObject.ctrlKey && !eventObject.altKey && !eventObject.metaKey) {
      return true; // Allow normal space key behavior
    }

    // to avoid changing behaviour for rest of the keys
    if ((!capturedKeys.includes(eventObject.keyCode) && !doubleQuoteKey) || 
        ((eventObject.keyCode === c || eventObject.keyCode === s) && !eventObject.ctrlKey && !eventObject.altKey && !eventObject.metaKey) || 
        (eventObject.keyCode === one || eventObject.keyCode === two || eventObject.keyCode === three || eventObject.keyCode === four || eventObject.keyCode === five || eventObject.keyCode === six) && document.activeElement.classList.contains('js-index-badge')) {
      return;
    }

    if (eventObject.keyCode === c && (eventObject.ctrlKey || eventObject.metaKey) && !eventObject.altKey) {
      let selectedText = window.getSelection().toString();
      if (selectedText && selectedText.length > 0) {
        return;
      }
    }

    if ([left, right].includes(eventObject.keyCode) && !preview_modal) { //to allow left/right arrow keys to work in text field in typeo/typel
      return true;
    }

    if (!eventObject.ctrlKey && eventObject.keyCode == m) {
      return true
    }

    if (eventObject.keyCode === s && eventObject.altKey && this.typing_stage === "type_o") {
      return
    }

    // Ctrl + S for Spll.
    if (eventObject.keyCode === s && eventObject.ctrlKey && !eventObject.altKey && !eventObject.metaKey) {
      eventObject.preventDefault();
      eventObject.stopPropagation();

      const container = this.currentTypingFieldContainer(eventObject.target);
      if (!container) return;
      const ottoSpellingPronunciationToggle = container.querySelector('.js-otto-spelling-pronunciation-toggle');
      if (ottoSpellingPronunciationToggle) {
        ottoSpellingPronunciationToggle.checked = !ottoSpellingPronunciationToggle.checked;
        ottoSpellingPronunciationToggle.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Ctrl+↑ or Page Up moves to the previous Latin field; Ctrl+↓ or Page Down moves to the next Latin field
    if ((eventObject.ctrlKey && (eventObject.keyCode === up || eventObject.keyCode === down)) ||
      (eventObject.keyCode === pgUp || eventObject.keyCode === pgDown))
      {
        eventObject.preventDefault();
        eventObject.stopPropagation();
      if ((eventObject.ctrlKey && eventObject.keyCode === up) || eventObject.keyCode === pgUp) {
        this.moveLatinFieldFocus(-1);
      } else if ((eventObject.ctrlKey && eventObject.keyCode === down) || eventObject.keyCode === pgDown) {
        this.moveLatinFieldFocus(1);
      }
      return;
    }

    // if the key '1' is pressed in the text field of ottoman spellings on type_o stage, then toggle the state of Turkish toggle
    if (eventObject.keyCode === one && !eventObject.altKey && !eventObject.ctrlKey && !eventObject.shiftKey && this.typing_stage === 'type_o'){
      const turkishToggle = event.target
        .closest('.js-entries-input')
        ?.querySelector('.js-otto-spellings-lang-toggles-container .js-marked-as-turkish-toggle');
      if (turkishToggle) {
        e.preventDefault();
        turkishToggle.checked = !turkishToggle.checked;
      } else {
        return
      }  
    }

    // Check if the '2' key is pressed without any alt key
    if (eventObject.keyCode === two && !eventObject.altKey && this.typing_stage === 'type_o') {
      const persianToggle = event.target
        .closest('.js-entries-input')
        ?.querySelector('.js-otto-spellings-lang-toggles-container .js-marked-as-persian-toggle');
      if (persianToggle) {
        e.preventDefault();
        persianToggle.checked = !persianToggle.checked;
      } else {
        return
      }     
    }

    // if the key '3' is pressed in the text field of alternate ottoman on type_o stage, then toggle the state of arabic toggle
    if (eventObject.keyCode === three && this.typing_stage === 'type_o') {
      // getting the arabic toggle, through the container of the target input field
      const arabicLetterToggle = event.target
        .closest('.js-entries-input')
        ?.querySelector('.js-otto-spellings-lang-toggles-container .js-marked-as-arabic-toggle');
      if (arabicLetterToggle) {
        e.preventDefault();
        arabicLetterToggle.checked = !arabicLetterToggle.checked;
      } else {
        return
      }
    }

    // if the key '4' is pressed in the text field of ottoman spellings on type_o stage, then toggle the state of Other Language toggle
    if (eventObject.keyCode === four && !eventObject.altKey && !eventObject.ctrlKey && !eventObject.shiftKey && this.typing_stage === 'type_o'){
      const otherLanguageToggle = event.target
        .closest('.js-entries-input')
        ?.querySelector('.js-otto-spellings-lang-toggles-container .js-marked-as-other-language-toggle');
      if (otherLanguageToggle) {
        e.preventDefault();
        otherLanguageToggle.checked = !otherLanguageToggle.checked;
      } else {
        return
      }  
    }

    // if the double quote key (") is pressed anywhere on type_o or type_l stage, then toggle the state of NoHarakat toggle
    if (eventObject.key === '"' && !eventObject.altKey && !eventObject.ctrlKey){
      const noHarakatToggles = document.querySelectorAll('.js-marked-as-no-harakat-toggle');
      if (noHarakatToggles) {
        e.preventDefault();
        noHarakatToggles[0].checked = !noHarakatToggles[0].checked;
      } else {
        return
      }
    }

    if (eventObject.keyCode === enter && typing_fields_arrow_connector && typing_fields_arrow_connector.selectedSpellingCheckboxes.length === 2) {
      typing_fields_arrow_connector.handleSpellingsLinkingThroughArrows();
      return;
    }

    // Shift + Space to click ZWS button
    if (eventObject.shiftKey && eventObject.keyCode === space && !eventObject.ctrlKey && !eventObject.altKey && !eventObject.metaKey) {
      eventObject.preventDefault();
      eventObject.stopPropagation();
      
      // Click the ZWS button using the target
      if (this.hasZwsBtnTarget) {
        this.zwsBtnTarget.click();
      }
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let moveDirection = 'next'
    
    // Allow number keys (1–6) to directly insert accented letters/apostrophes without Alt
    if ((!eventObject.altKey && this.typing_stage == 'type_l') && (eventObject.keyCode == one || eventObject.keyCode == two || eventObject.keyCode == three || eventObject.keyCode == four || eventObject.keyCode == five || eventObject.keyCode == six)) {
      if (eventObject.keyCode == one) {
        this.straightApostropheBtnTarget.click()
      } else if (eventObject.keyCode == two) {
        this.startQuoteBtnTarget.click()
      } else if (eventObject.keyCode == three) {
        this.endQuoteBtnTarget.click()
      } else if (eventObject.keyCode == four) {
        this.aWithCircumflexTarget.click()
      } else if (eventObject.keyCode == five) {
        this.iWithCircumflexTarget.click()
      } else if(eventObject.keyCode == six) {
        this.uWithCircumflexTarget.click()
      }    
    } else if(eventObject.shiftKey && eventObject.keyCode == enter) {
      let selectedText = window.getSelection().toString();
      // in type_o add simple ottomans alternate spelling values if in misspelled case and focus is not on simple ottoman value
      // in type_l add alterative entry manually if text is not selected
      if ((this.typing_stage == 'type_o' && !(this.hasMisspelledCheckBoxTarget && this.misspelledCheckBoxTarget.checked && this.lastFocusedField.classList.contains('js-simple-ottoman-alternative-value'))) || 
        this.typing_stage == 'type_l') {
        if (selectedText) {
          this.addAlternativeEntryManually();
          this.lastFocusedField.value = selectedText;
          this.filterValidCharacters({ currentTarget: this.lastFocusedField });
        }
        else {
          this.addAlternativeEntryManually();
        }
      } else {
        this.copySelectedTextToNextTranscriptionField(selectedText);
      }
    } 
    // Alt+Enter: In TypeL, if the field value has a variant-generating pattern (dot or dash), trigger 'Generate' button for the text field; otherwise, Copy the plain latin value to a new field.
    else if ((eventObject.altKey && eventObject.keyCode == enter)) {
      const currentField = e.target;
      const latinValue   = currentField.value;
      if (!latinValue) return;

      // Check if the latin value contains variant-generating patterns (dots or dashes) and if the field is the first one
      const typingFieldContainer         = currentField.closest('.js-typing-value-container');
      const latinFields                  = typingFieldContainer.querySelectorAll('.js-text-field');
      const isFirstField                 = latinFields[0] === currentField;
      if (this.isTypingLatinStage() && this.hasVariantGeneratingPattern(latinValue) && isFirstField) {
        const syllableVariantGeneratorBtn = typingFieldContainer?.querySelector('.js-syllable-variant-generator');
        if (syllableVariantGeneratorBtn) {
          syllableVariantGeneratorBtn.click();
        }
      } else if(!this.hasVariantGeneratingPattern(latinValue)) {
        this.addAlternativeEntryManually();
        this.lastFocusedField.value = latinValue; //copy value(including whitespace) to new alternative field
        this.filterValidCharacters({ currentTarget: this.lastFocusedField });
      }
    } 
    /* ctrl/cmd + enter and up key for move to previous item and else for moving to next item*/
    else if (
      this.isNavigateToPreviousItemShortcut(eventObject) ||
      eventObject.keyCode == up ||
      eventObject.keyCode == down ||
      (eventObject.keyCode == enter && !isLatinHistoryModalOpen)
    ) {
      if (this.isNavigateToPreviousItemShortcut(eventObject)) {
        moveDirection = "prev";
      } else if (eventObject.keyCode == up) {
        moveDirection = "prev";
      } else { // Enter, down
        moveDirection = "next";
      }

      // when current item container of badge is not in edit mode
      if (this.currentItemIndexContainerTarget.contentEditable == 'inherit' || this.currentItemIndexContainerTarget.contentEditable == 'false' ) {
        typing_form.submit(e, moveDirection)
      } else {
        let editToWrittenEntryItem = this.currentItemIndexContainerTarget
        if ((!/[0-9]/.test(event.key) && event.keyCode !== 13)|| (event.keyCode === 13 && editToWrittenEntryItem.innerText == '')) {
          event.preventDefault();
        } else if (event.keyCode === 13 && /[0-9]/.test(editToWrittenEntryItem.innerText)) {
          this.editToWrittenEntryItem();
        }
      }
    } else if(eventObject.keyCode == m && eventObject.ctrlKey) {
      this.contextViewBtnTarget.click()
    }
  }

  // For page_set
  // TODO: should be separate preview controller
  preview(e) {
    let stageUrl = this.previewUrlForStage(this.typing_stage, e.currentTarget.dataset.pageSetId)
    let data = {
      current_item_id: this.current_item_id,
      current_item_type: this.typing_for
    };
    $.ajax({
      url: stageUrl,
      type: 'GET',
      data: data
    });
  }

  previewUrlForStage(typing_stage, setId) {
    switch(typing_stage){
    case 'type_o':
      return Routes.preview_type_o_set_path({ id: setId })
      break
    case 'type_l':
      return Routes.preview_type_l_set_path({ id: setId })
      break
    }
  }
  
  // Why is it async
  async toggleThumbnailsVisibility(e){
    // TODO: Use separate classes for css and js
    let sidebarContainer     = document.getElementById('js-typing-sidebar-container');
    let areThumbnailsVisible = sidebarContainer && !sidebarContainer.classList.contains('hide_thumbnail');
    let updatedThumbnailFlag = !areThumbnailsVisible;
    
    await Rails.ajax({
      type: "PATCH",
      url: "/user_settings/toggle_thumbnail_preview.js",
      data: `thumbnail_flag=${updatedThumbnailFlag}`,
      success: function(){
        location.reload();
      }
    });
  }

  misspelledCheckedWithNoOptions(){
    let misspelledOptionsContainer = document.getElementById('misspelled-options')
    let misspelledOptionsCheckboxes = misspelledOptionsContainer.querySelectorAll('.js-misspelled-option-checkboxes');
    let anyChecked = false;
    misspelledOptionsCheckboxes.forEach(checkbox => {
      if(checkbox.checked){
        anyChecked = true
      }
    });

    return (this.misspelledCheckBoxTarget.checked && !anyChecked)
  }

  // this method removed notes related styling from typing edit area
  removeNotesStyling(e){
    let currentItemNotesCount = this.currentItemNotes;

    if (currentItemNotesCount == 0 && 
        e.target.dataset.noteStage == this.typing_stage){  
      this.removeNotesStylingInTypingEditArea();
    }
  }

  removeNotesStylingInTypingEditArea(){
    $('.js-item-container').removeClass('border border-danger border-2');
    $('.js-progress-bar-slider').removeClass('bg-danger');
    $('.js-progress-bar').css('background-color', '');
  }

  // this method adds notes related styling from typing edit area
  addNotesStyling(){
    this.setCurrentItemNotes(this.currentItemNotes + 1);
    this.displayNotesStylingInTypingEditArea();
  }

  displayNotesStylingInTypingEditArea(){
    $('.js-item-container').addClass('border border-danger border-2');
    $('.js-progress-bar-slider').addClass('bg-danger');
    $('.js-progress-bar').css('background-color', '#FFB6C1');
  }

  // this method updates type_o/type_l alternative values assigned numbers
  updateAlternativeValueAssignedNumber(e) {
    const clickedBtn           = e.currentTarget;
    const clickedBtnIdentifier = parseInt(clickedBtn.getAttribute('data-add-alternative-btn-identifier'));

    // Updating identifier numbers of unclicked add alternative btns
    // also setting assigned values of hidden fields
    this.updateAddAltBtnsAndAssignedValueFieldsAfterSelectedField(clickedBtnIdentifier);
    
    // Setting Identifier numbers of new rendered add alternative btns
    // also setting assigned values of hidden fields
    this.setNewAddAltBtnsAndAssignedValueFields(clickedBtn, clickedBtnIdentifier);
  }

  // Helper function to update identifier numbers of unclicked add alternative btns
  updateAddAltBtnsAndAssignedValueFieldsAfterSelectedField(selectedFieldIdentifier){
    const addAlternativeBtns = $('.js-add-alternative-btn');
    addAlternativeBtns.each((index, addAlternativeBtn) => {
      let unclickedBtnPrevIdentifier = parseInt(addAlternativeBtn.getAttribute('data-add-alternative-btn-identifier'));
      let updatedIdentifier          = unclickedBtnPrevIdentifier + 1;
      let isAddAlternativeBottomBtn  = addAlternativeBtn.getAttribute('data-from-add-alternative-button');

      if (unclickedBtnPrevIdentifier <= selectedFieldIdentifier && !isAddAlternativeBottomBtn) return;
      this.setAddAltBtnIdentifier(addAlternativeBtn, updatedIdentifier);
      // Updating Assigned Numbers Hidden Fields Value if unclicked btn is not bottom button
      if(!isAddAlternativeBottomBtn){
        this.updateAltEntryAssignedNumber(unclickedBtnPrevIdentifier, updatedIdentifier);
      }
    });
  }

  // Helper function to set identifier number and assigned Value of new rendered add alternative btn
  setNewAddAltBtnsAndAssignedValueFields(clickedBtn, clickedBtnIdentifier){
    const newAddAlternativeBtn               = document.querySelector(`[data-add-alternative-btn-identifier='-1']`);
    const isFromBottomAlternativeBtn         = clickedBtn.getAttribute('data-from-add-alternative-button');
    const updatedAddAlternativeBtnIdentifier = clickedBtnIdentifier + 1;
    
    // checking if clicked btn is bottom add alternative btn
    if (isFromBottomAlternativeBtn == 'true') {
      // set new btn identifier and assigned value equal to clicked btn and then increment clicked btn identifier number by 1 
      // because bottom button is at the most bottom of entries that's why it's identifier value will be highest 
      this.setAddAltBtnIdentifier(newAddAlternativeBtn, clickedBtnIdentifier);
      this.updateAltEntryAssignedNumber(-1, clickedBtnIdentifier);
      this.setAddAltBtnIdentifier(clickedBtn, updatedAddAlternativeBtnIdentifier);
    } else {
      // set new alt btn identifier and assigned value one more than clicked btn
      this.setAddAltBtnIdentifier(newAddAlternativeBtn, updatedAddAlternativeBtnIdentifier);
      this.updateAltEntryAssignedNumber(-1, updatedAddAlternativeBtnIdentifier);
    }
  }

  // Setter function to set identifier value of all alternative btns
  setAddAltBtnIdentifier(addAlternativeBtn, updatedIdentifier) {
    addAlternativeBtn.setAttribute('data-add-alternative-btn-identifier', updatedIdentifier);
  }

  // Helper function to update Hidden Field Assigned Number
  updateAltEntryAssignedNumber(prevAssignedValue, updatedAssignedValue ){
    const assignedNumberHiddenField = $(`.assigned-number-${prevAssignedValue}`);

    if (!assignedNumberHiddenField.length) return;
    if (assignedNumberHiddenField.length > 1){
      //updating second value as previously changed assigned_value would become equal to the next value
      assignedNumberHiddenField[1].value = updatedAssignedValue;
      assignedNumberHiddenField[1].setAttribute('class', `assigned-number-${updatedAssignedValue} js-otto-spelling-assigned-number`);
    } else {
      assignedNumberHiddenField[0].value = updatedAssignedValue;
      assignedNumberHiddenField[0].setAttribute('class', `assigned-number-${updatedAssignedValue} js-otto-spelling-assigned-number`);
    }
  }

  getCurrentOttoFieldToggle(typingField, toggleName) {
    const toggleSelectors = {
      rootToggle: '.js-marked-as-root-toggle',
      singularToggle: '.js-marked-as-singular-toggle',
      derivedToggle: '.js-marked-as-derived-value-toggle',
      pluralToggle: '.js-marked-as-plural-value-toggle',
      relatedToggle: '.js-marked-as-related-value-toggle',
      oppositeToggle: '.js-marked-as-opposite-value-toggle', // # Opp. → Ant.(Antonym)  (DB attribute remains :is_opposite) ref#1874
      synonymToggle: '.js-marked-as-synonym-value-toggle',
      counterpartToggle: '.js-marked-as-counterpart-value-toggle',
      nearSynonymToggle: '.js-marked-as-near-synonym-toggle',
      closeToAccurateToggle: '.js-is-close-to-accurate-toggle',
      accurateToggle: '.js-is-accurate-toggle',
      corruptedToggle: '.js-is-corrupted-toggle',
      misspelledToggle: '.js-is-misspelled-toggle',
      mispronouncedToggle: '.js-marked-as-mispronounced-toggle',
      misUsedToggle: '.js-is-misused-toggle',
      moreUsedToggle: '.js-is-more-used-toggle',
      vulgarToggle: '.js-marked-as-vulgar-toggle',
      unknownToggle: '.js-marked-as-unknown-toggle',
      stronglyRelatedToggle:'.js-marked-as-strongly-related-toggle',
      weaklyRelatedToggle: '.js-marked-as-weakly-related-toggle',
      moderatelyRelatedToggle: '.js-marked-as-moderately-related-toggle',
      unrelatedToggle: 'js-marked-as-unrelated-value-toggle',
      turkishToggle: '.js-marked-as-turkish-toggle',
      turkishByAuthorToggle: '.js-marked-as-turkish-by-author-toggle',
      verbToggle: '.js-marked-as-verb-toggle',
      alternateSpellingToggle: '.js-marked-as-alternate-spelling-toggle',
      commonRootToggle: '.js-is-common-root-toggle',
      lessUsedToggle: '.js-is-less-used-toggle',
      lessAccurateToggle: '.js-is-less-accurate-toggle'
    };

    const toggleSelector  = toggleSelectors[toggleName];

    return toggleSelector ? typingField.querySelector(toggleSelector) : null;
  }

  // RULES FOR TOGGLE BUTTONS & Dependencies Between Labels:

  // If a word is singular, it must be a Root, but not every Root is singular.
  // If a word is plural, it must be Derived, but not every Derived is plural.
  // If a word is opposite, it must be Related, but not every Related is opposite.

  // Turning Off Dependencies:

  // If Root is turned off, Singular must also turn off automatically.
  // If Derived is turned off, Plural must also turn off automatically.
  // If Related is turned off, Opposite must also turn off automatically.

  // Turning On Dependencies:

  // If Singular is turned on, Root must automatically turn on.
  // If Plural is turned on, Derived must automatically turn on.
  // If Opposite is turned on, Related must automatically turn on.

  // Maintaining Independence:

  // When Singular and Root are both active, turning off Singular must not turn off Root.
  // When Plural and Derived are both active, turning off Plural must not turn off Derived.
  // When Opposite and Related are both active, turning off Opposite must not turn off Related.
  
  // TODO: move these methods in a separate controller
  
  // Rules:
  // 1_ If Root is turned On, Derived(Drv.), Plural(Plr.), Related(Rel.) & Opposite(Opp.) should be turned off
  // 2_ If Root is turned Off, Singular (Sing.) must also turn off automatically.
  // Note: Turning off Opposite due to an intermediate dependency of Opp. on Rel.
  updateRootRelatedOtherTogglesStates(e) {
    const rootToggleCheckbox = e.target;
    const currentField       = this.getCurrentTypingField(rootToggleCheckbox);
    
    const isChecked          = rootToggleCheckbox.checked;

    let markedAsDerivedToggle  = this.getCurrentOttoFieldToggle(currentField, 'derivedToggle')
    let markedAsPluralToggle   = this.getCurrentOttoFieldToggle(currentField, 'pluralToggle')
    let markedAsRelatedToggle  = this.getCurrentOttoFieldToggle(currentField, 'relatedToggle')
    let markedAsOppositeToggle = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')
    let markedAsSingularToggle = this.getCurrentOttoFieldToggle(currentField, 'singularToggle')

    if (isChecked) {
      if(markedAsPluralToggle) markedAsPluralToggle.checked     = false;
      if(markedAsRelatedToggle) markedAsRelatedToggle.checked   = false;
      if(markedAsOppositeToggle) markedAsOppositeToggle.checked = false;
    } else {
      if(markedAsSingularToggle) markedAsSingularToggle.checked = false;
    }

    // Root on/off on the card below gates Infl./Drvl. on the card above.
    typeo_form?.scheduleMorphologicalToggleStatesUpdate();
  }

  // Rules: 
  // 1_ If Singular(Sing.) is turned On, the Root should be turned on automatically(bcz all Sing. are Roots.)
  // 2_ If Singular(Sing.) is turned On, turn off the Derived(Drv.), Plural(Plr.), Related(Rel.) & Opposite(Opp.) should be turned off
  // Note: Turning off Opposite due to an intermediate dependency of Opp. on Rel.
  updateSingularRelatedOtherTogglesStates(e) {
    const singularToggleCheckbox = e.target;
    const currentField           = this.getCurrentTypingField(singularToggleCheckbox);

    const isChecked              = singularToggleCheckbox.checked;

    let markedAsRootToggle     = this.getCurrentOttoFieldToggle(currentField, 'rootToggle')
    let markedAsDerivedToggle  = this.getCurrentOttoFieldToggle(currentField, 'derivedToggle')
    let markedAsPluralToggle   = this.getCurrentOttoFieldToggle(currentField, 'pluralToggle')
    let markedAsRelatedToggle  = this.getCurrentOttoFieldToggle(currentField, 'relatedToggle') 
    let markedAsOppositeToggle = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')

    if (isChecked) {
      if(markedAsRootToggle) markedAsRootToggle.checked     = true;
      if(markedAsDerivedToggle) markedAsDerivedToggle.checked  = false;
      if(markedAsPluralToggle) markedAsPluralToggle.checked   = false;
      if(markedAsRelatedToggle) markedAsRelatedToggle.checked  = false;
      if(markedAsOppositeToggle) markedAsOppositeToggle.checked = false;
    }

    // Singular auto-enables Root, which affects gating for this card and neighbors below.
    typeo_form?.scheduleMorphologicalToggleStatesUpdate();
  }

  // Rules:
  // 1_ If Derived(Drv.) is turned On, Root, Singular(Sing.), Related(Rel.) & Opposite(Opp.) should be turned off.
  // 2_ If Derived(Drv.) is turned Off, Plural must also turn off automatically.
  // Note: Turning off Opposite due to an intermediate dependency of Opp. on Rel.
  updateDerivedRelatedOtherTogglesStates(e) {
    const derivedToggleCheckbox = e.target;
    const currentField          = this.getCurrentTypingField(derivedToggleCheckbox);

    const isChecked             = derivedToggleCheckbox.checked;

    let markedAsRootToggle     = this.getCurrentOttoFieldToggle(currentField, 'rootToggle')
    let markedAsSingularToggle = this.getCurrentOttoFieldToggle(currentField, 'singularToggle')
    let markedAsRelatedToggle  = this.getCurrentOttoFieldToggle(currentField, 'relatedToggle') 
    let markedAsOppositeToggle = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')
    let markedAsPluralToggle   = this.getCurrentOttoFieldToggle(currentField, 'pluralToggle')

    if (isChecked) {
      if(markedAsSingularToggle) markedAsSingularToggle.checked = false;
      if(markedAsRelatedToggle) markedAsRelatedToggle.checked   = false;
      if(markedAsOppositeToggle) markedAsOppositeToggle.checked = false;
    } else {
      if(markedAsPluralToggle) markedAsPluralToggle.checked = false;
    }
  }

  // Rules: 
  // 1_ If Plural(Plr.) is turned On, Derived(Drv.) should be turned on automatically
  // 2_ If Plural(Plr.) is turned On, Root, Singular(Sing.), Related(Rel.) & Opposite(Opp.) should be turned off.
  // Note: Turning off Opposite due to an intermediate dependency of Opp. on Rel.
  updatePluralRelatedOtherTogglesStates(e) {
    const pluralToggleCheckbox = e.target;
    const currentField         = this.getCurrentTypingField(pluralToggleCheckbox);

    const isChecked            = pluralToggleCheckbox.checked;

    let markedAsRootToggle     = this.getCurrentOttoFieldToggle(currentField, 'rootToggle')
    let markedAsSingularToggle = this.getCurrentOttoFieldToggle(currentField, 'singularToggle')
    let markedAsDerivedToggle  = this.getCurrentOttoFieldToggle(currentField, 'derivedToggle')
    let markedAsRelatedToggle  = this.getCurrentOttoFieldToggle(currentField, 'relatedToggle') 
    let markedAsOppositeToggle = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')

    if (isChecked) {
      if(markedAsDerivedToggle) markedAsDerivedToggle.checked  = true;
      if(markedAsRootToggle) markedAsRootToggle.checked     = false;
      if(markedAsSingularToggle) markedAsSingularToggle.checked = false;
      if(markedAsRelatedToggle) markedAsRelatedToggle.checked  = false;
      if(markedAsOppositeToggle) markedAsOppositeToggle.checked = false;
    }
  }

  // Rules:
  // 1_ If Opposite(Opp.) is turned On, Related(Rel.) should be turned on autimatically.
  // 2_ If Opposite(Opp.) is turned Off, Near Synonym(NrSyn.), Synonym(Syn.), Derived(Drv.) & Plural(Plr.) should be turned off due to intermediate dependencies.
  // Note: All opposites (Opp.) are Related (Rel.) at the same time (turning opposite on should turn on the related as well)
  updateOppositeRelatedOtherTogglesStates(e) {
    const oppositeToggleCheckbox = e.target;
    const currentField           = this.getCurrentTypingField(oppositeToggleCheckbox);

    const isChecked              = oppositeToggleCheckbox.checked;

    // let markedAsRelatedToggle   = this.getCurrentOttoFieldToggle(currentField, 'relatedToggle')
    let markedAsStronglyRelatedToggle   = this.getCurrentOttoFieldToggle(currentField, 'stronglyRelatedToggle')
    let markedAsModeratelyRelatedToggle = this.getCurrentOttoFieldToggle(currentField, 'moderatelyRelatedToggle')
    let markedAsWeaklyRelatedToggle     = this.getCurrentOttoFieldToggle(currentField, 'weaklyRelatedToggle')
    let markedAsRootToggle              = this.getCurrentOttoFieldToggle(currentField, 'rootToggle')
    let markedAsSingularToggle          = this.getCurrentOttoFieldToggle(currentField, 'singularToggle')
    let markedAsNearSynonymToggle       = this.getCurrentOttoFieldToggle(currentField, 'nearSynonymToggle')
    let markedAsSynonymToggle           = this.getCurrentOttoFieldToggle(currentField, 'synonymToggle')    
    let markedAsDerivedToggle           = this.getCurrentOttoFieldToggle(currentField, 'derivedToggle')
    let markedAsPluralToggle            = this.getCurrentOttoFieldToggle(currentField, 'pluralToggle')
    
    if (isChecked) {
      // markedAsRelatedToggle.checked   = true;
      markedAsStronglyRelatedToggle.checked   = false;
      markedAsModeratelyRelatedToggle.checked = false;
      markedAsWeaklyRelatedToggle.checked     = false;
      markedAsRootToggle.checked              = false;
      markedAsSingularToggle.checked          = false;
      markedAsNearSynonymToggle.checked       = false;
      markedAsSynonymToggle.checked           = false;
      markedAsDerivedToggle.checked           = false;
      markedAsPluralToggle.checked            = false;
    }
  }

  // Rules: 
  // 1_ If Related(Rel.) is turned On, Root, Singular(Sing.), Derived(Drv.), Plural(Plr.), Near Synonym(NrSyn.) & Synonym(Syn.) should be turned off.
  // 2_ If Related(Rel.) is turned Off, Opposite(Opp.) should be turned off automatically
  // Note: Opposite (Opp.) is dependent on related, if both are turned on, and user turns off Related (Rel.) then Opposite (Opp.) should be turned off automatically
  // Turning on Relted (Rel.) will not turn on the Opposite (Opp.) because Related is not dependent on Opposite
  // Note: here Singular(Sing.) is turned off due to intermediate dependency on Root, and Synonym is turned off due to intermediate dependency on Near Synonym(NrSyn.)
  updateRelatedOtherTogglesStates(e) {
    const relatedToggleCheckbox = e.target;
    const currentField          = this.getCurrentTypingField(relatedToggleCheckbox);

    const isChecked             = relatedToggleCheckbox.checked;

    let markedAsRootToggle        = this.getCurrentOttoFieldToggle(currentField, 'rootToggle')
    let markedAsSingularToggle    = this.getCurrentOttoFieldToggle(currentField, 'singularToggle')
    let markedAsDerivedToggle     = this.getCurrentOttoFieldToggle(currentField, 'derivedToggle')
    let markedAsPluralToggle      = this.getCurrentOttoFieldToggle(currentField, 'pluralToggle')
    let markedAsNearSynonymToggle = this.getCurrentOttoFieldToggle(currentField, 'nearSynonymToggle')
    let markedAsSynonymToggle     = this.getCurrentOttoFieldToggle(currentField, 'synonymToggle')
    let markedAsOppositeToggle    = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')

    let moderatelyRelatedToggle   = this.getCurrentOttoFieldToggle(currentField, 'moderatelyRelatedToggle')
    let weaklyRelatedToggle       = this.getCurrentOttoFieldToggle(currentField, 'weaklyRelatedToggle')

    if (isChecked) {
      markedAsRootToggle.checked        = false;
      markedAsSingularToggle.checked    = false;
      markedAsDerivedToggle.checked     = false;
      markedAsPluralToggle.checked      = false;
      markedAsNearSynonymToggle.checked = false;
      markedAsSynonymToggle.checked     = false;
      moderatelyRelatedToggle.checked   = false;
      weaklyRelatedToggle.checked       = false;
      markedAsOppositeToggle.checked    = false;
    }
  }

  applyStronglyRelatedSelection(e) {
    this.updateRelatedOtherTogglesStates(e);
  }

  applyModeratelyRelatedSelection(e) {
    const moderatelyRelatedToggleCheckbox = e.target;
    const currentField                    = this.getCurrentTypingField(moderatelyRelatedToggleCheckbox);

    const isChecked = moderatelyRelatedToggleCheckbox.checked;

    let weaklyRelatedToggle     = this.getCurrentOttoFieldToggle(currentField, 'weaklyRelatedToggle')
    let stronglyRelatedToggle   = this.getCurrentOttoFieldToggle(currentField, 'stronglyRelatedToggle')
    let oppositeToggle          = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')

    if (isChecked) {
      weaklyRelatedToggle.checked   = false;
      stronglyRelatedToggle.checked = false; 
      oppositeToggle.checked        = false;     
    }
  }

  applyWeaklyRelatedSelection(e) {
    const weaklyRelatedToggleCheckbox = e.target;
    const currentField                = this.getCurrentTypingField(weaklyRelatedToggleCheckbox);

    const isChecked = weaklyRelatedToggleCheckbox.checked;

    let markedAsOppositeToggle  = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')
    let moderatelyRelatedToggle = this.getCurrentOttoFieldToggle(currentField, 'moderatelyRelatedToggle')
    let stronglyRelatedToggle   = this.getCurrentOttoFieldToggle(currentField, 'stronglyRelatedToggle')

    if (isChecked) {
      markedAsOppositeToggle.checked  = false;
      moderatelyRelatedToggle.checked = false;
      stronglyRelatedToggle.checked   = false;      
    }
  } 

  getCurrentTypingField(current_div){
    return current_div.closest('.js-entries-input');
  }

  togglesToHideIfUnrelatedToggleIsChecked(field){
    const toggleNames = [
      'closeToAccurateToggle',
      'accurateToggle',
      'corruptedToggle',
      'misspelledToggle',
      'mispronouncedToggle',
      'misUsedToggle',
      'moreUsedToggle',
      'vulgarToggle',
      'unknownToggle',
      'rootToggle',
      'singularToggle',
      'nearSynonymToggle',
      'synonymToggle',
      'derivedToggle',
      'pluralToggle',
      'relatedToggle',
      'stronglyRelatedToggle',
      'weaklyRelatedToggle',
      'moderatelyRelatedToggle',
      'oppositeToggle',
      'alternateSpellingToggle',
      'commonRootToggle'
    ];

    const toggles = [];
    for (const name of toggleNames) {
      const el = this.getCurrentOttoFieldToggle(field, name);
      if (el) toggles.push(el);
    }
    return toggles;
  }

  handleEntryWordLinkageTogglesVisibility(e) {
    const unrelatedToggleCheckbox = e.target;
    const isChecked               = unrelatedToggleCheckbox.checked;
    const currentLinkingField     = this.getCurrentTypingField(unrelatedToggleCheckbox);
    const linkingTogglesFields    = currentLinkingField.querySelectorAll('.js-hide-molecule-linking-toggles-on-unrelated');
    
    const togglesToReset = this.togglesToHideIfUnrelatedToggleIsChecked(currentLinkingField);

    if (isChecked) {
      togglesToReset.forEach(t => { t.checked = false; });

      linkingTogglesFields.forEach(linkingToggleField => {
        linkingToggleField.classList.add('d-none')
      });
    } else {
      linkingTogglesFields.forEach(linkingToggleField => {
        linkingToggleField.classList.remove('d-none')
      });
    }
  }

  // Rules: 
  // 1_ If NearSynonym (NrSyn.) is turned On, Synonym(Syn.), Related(Rel.) & Opposite(Opp.) should be turned off.
  // 2_ If NearSynonym (NrSyn.) is turned Off, Synonym(Syn.) should be turned off automatically.
  // Note: Turning off Opposite due to an intermediate dependency of Opp. on Rel.
  applyNearSynonymToggleStateChange(e) {
    const nearSynonymToggleCheckbox = e.target;
    const currentField              = this.getCurrentTypingField(nearSynonymToggleCheckbox);

    const isChecked                = nearSynonymToggleCheckbox.checked;
    
    let markedAsRelatedToggle  = this.getCurrentOttoFieldToggle(currentField, 'relatedToggle')
    let markedAsOppositeToggle = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')
    let markedAsSynonymToggle  = this.getCurrentOttoFieldToggle(currentField, 'synonymToggle')

    if (isChecked) {
      if(markedAsSynonymToggle) markedAsSynonymToggle.checked  = false;
      if(markedAsRelatedToggle) markedAsRelatedToggle.checked  = false;
      if(markedAsOppositeToggle) markedAsOppositeToggle.checked = false;
    }
  }

  // Rules: 
  // 1_ If Synonym(Syn.) toggle is turned On, Near Synonym(NrSyn.) toggle should be turned off automatically.
  // 2_ If Synonym(Syn.) toggle is turned On, Related(Rel.) should be turned off(Due to intermediate dependency on NearSynonym (NrSyn.))
  // 3_ If Synonym(Syn.) toggle is turned On, Opposite(Opp.)[New name -> Antonym (Ant.)] should be turned off(Due to intermediate dependency on Related(Rel.))
  // Note: Turning off Opposite due to an intermediate dependency of Opp. on Rel.
  updateSynonymRelatedOtherTogglesStates(e) {
    const synonymToggleCheckbox = e.target;
    const currentField          = this.getCurrentTypingField(synonymToggleCheckbox);

    const isChecked             = synonymToggleCheckbox.checked;
    let markedAsNearSynonymToggle = this.getCurrentOttoFieldToggle(currentField, 'nearSynonymToggle')
    let markedAsRelatedToggle     = this.getCurrentOttoFieldToggle(currentField, 'relatedToggle')
    let markedAsOppositeToggle    = this.getCurrentOttoFieldToggle(currentField, 'oppositeToggle')
    if (isChecked) {
      if (markedAsNearSynonymToggle) markedAsNearSynonymToggle.checked = false;
      if (markedAsRelatedToggle) markedAsRelatedToggle.checked         = false;
      if (markedAsOppositeToggle) markedAsOppositeToggle.checked       = false;
    }
  }

  enableDragFromTextField(markedAsPrimaryRadioBtn) {
    const dragHandle = markedAsPrimaryRadioBtn.closest('.js-entries-input')?.querySelector('.js-drag-handle');
    dragHandle?.classList.remove("d-none");
    const otherValueContainer = markedAsPrimaryRadioBtn.closest('.js-other-value-container');
    otherValueContainer?.classList.remove("js-not-sortable"); 
    otherValueContainer?.classList.add("js-sortable-item");    
  }

  disableDragFromTextField(markedAsPrimaryRadioBtn) {
    const dragHandle = markedAsPrimaryRadioBtn.closest('.js-entries-input')?.querySelector('.js-drag-handle');
    dragHandle?.classList.add("d-none");
    const otherValueContainer = markedAsPrimaryRadioBtn.closest('.js-other-value-container');
    otherValueContainer?.classList.add("js-not-sortable");
    otherValueContainer?.classList.remove("js-sortable-item");
  }

  handleUiUpdateForPrimarySpellingChange(e) {
    const selectedRadioBtn = e.target;
    const fieldMarkedAsPrimaryContainer = selectedRadioBtn.closest('.js-entries-input');
    const misspelledCheckbox = document.querySelector("#chk-to-be-misspelled");
    
    const isMisspelledChecked = misspelledCheckbox?.checked;

    // const primarySpellingContainer = $(".js-primary-spellings-container");

    const primarySpellingContainer = isMisspelledChecked 
        ? $(".js-corrected-spellings-container") 
        : $(".js-primary-spellings-container");

    const primarySpellingRadioBtn = primarySpellingContainer[0]?.querySelector('.js-marked-as-primary-radio-btn');
    const primaryTogglesContainer = primarySpellingContainer[0]?.querySelector('.js-typing-field-btm-right-container');

    this.resetEntryWordSpellingsExistingLinkages(fieldMarkedAsPrimaryContainer);
    this.addPrimaryFlagClassOnFieldMarkedAsPrimary(fieldMarkedAsPrimaryContainer);
    // this.handleComponentToggleVisibility(fieldMarkedAsPrimaryContainer);
    this.updatePrimaryStatusForOttomanFields(fieldMarkedAsPrimaryContainer);
    typeo_form.handleSpellingLinkagesMoleculeIcon(fieldMarkedAsPrimaryContainer);
    typeo_form.updateDestroyValueOFAllEntrySpellingLinkagesOfSelectedContainer(fieldMarkedAsPrimaryContainer, 'false');

    const controllerInstance = this;
    $(".js-marked-as-primary-radio-btn").each(function () {
      const isChecked = this === selectedRadioBtn;
      this.checked = isChecked;
      this.value = isChecked ? "true" : "false";

      $(this).toggleClass("bg-success primary-spelling-border", isChecked);

    // show/hide Incorrect + UnUsed wrappers per field
    const entriesInput = this.closest('.js-entries-input');
    const primaryOnlyToggles = entriesInput?.querySelectorAll('.js-primary-only-toggle');
    primaryOnlyToggles?.forEach(el => el.classList.toggle('d-none', !isChecked));

      if (this === primarySpellingRadioBtn) {
        primaryTogglesContainer?.classList.toggle('d-none', !isChecked);
      } else {
        const otherValuesContainer = this.closest('.js-other-value-container');
        //otherValuesContainer?.querySelector('.typing-field-btm-right-container')?.classList.toggle('d-none', !isChecked);
      }

      if (isChecked) {
        $(".js-text-field").removeClass("primary-spelling-border");
        const textField = this.closest('.js-entries-input')?.querySelector('.js-text-field');
        textField?.classList.add("primary-spelling-border");
        controllerInstance.disableDragFromTextField(this);
      } else {
        controllerInstance.enableDragFromTextField(this);
      }
    });
    this.updateComponentToggleVisibility();
    this.updateDerivedToggleVisibility();
    this.updateVerbToggleSeparatorVisibility();
  }

  updatePrimaryStatusForOttomanFields(fieldMarkedAsPrimary) {
    const allPrimaryFields = document.querySelectorAll('.js-entries-input.js-primary-spelling');
    // Remove js-primary-spelling class from all fields except the new primary field
    allPrimaryFields.forEach(field => {
      if (field !== fieldMarkedAsPrimary) {
        field.classList.remove('js-primary-spelling');
      }
    });

    // Add js-primary-spelling class to the new primary field
    fieldMarkedAsPrimary.classList.add('js-primary-spelling');           
  }

  // Currently unused // TODO: Remove after confirming new method updateComponentToggleVisibility() is stable.
  handleComponentToggleVisibility(fieldMarkedAsPrimaryContainer) {
    const previosPrimarySpelling = $('.js-entries-input.js-primary-spelling')[0];
    const ottomanTypingFields    = $('.js-entries-input');
    
    let afterPrimarySpelling = false;
    
    previosPrimarySpelling?.classList.remove('js-primary-spelling');
    fieldMarkedAsPrimaryContainer.closest('.js-entries-input').classList.add('js-primary-spelling');
    // return
    Array.from(ottomanTypingFields).forEach(spellingField => {
      // Remove component toggle of typing fields above primary spelling
      const componentToggleContainer = spellingField.querySelector('.js-marked-as-component-toggle-container');
      const componentToggle          = componentToggleContainer?.querySelector('.js-marked-as-component-toggle');
      if (componentToggle) {
        componentToggle.checked = false;
        componentToggleContainer.classList.add('d-none');
        this.handleSpellingsVisibilityInLinkageModal(false);
      }

      if (spellingField.classList.contains('js-primary-spelling')) {
        afterPrimarySpelling = true;
        return;
      }

      if (afterPrimarySpelling) {
      // Add component toggle of typing fields below primary spelling
        spellingField.querySelector('.js-marked-as-component-toggle-container')?.classList.remove('d-none');
      }
    });
  }

  resetEntryWordSpellingsExistingLinkages(fieldMarkedAsPrimaryContainer){
    const formContainer          = fieldMarkedAsPrimaryContainer.closest('#typeo-fields-container');
    const spellingLinkagesModals = formContainer.querySelectorAll('.js-spelling-linkage-modal');
    
    spellingLinkagesModals.forEach(entryWordSpellingLinkage => {
      // destroy existing linkages
      typeo_form.updateDestroyValueOFAllEntrySpellingLinkagesOfSelectedContainer(entryWordSpellingLinkage, 'true');

      // Reset sources
      this.resetEntryWordLinkageSources(entryWordSpellingLinkage);
      
      // Reset Toggles
      this.resetEnrtyWordSpellingLinkageToggles(entryWordSpellingLinkage);
      
      //remove primary spelling flag from previous primary spellings fields
      this.removePrimaryFlagClassFromPreviousPrimarySpellingLinkages(entryWordSpellingLinkage);
    });
  }

  resetEntryWordLinkageSources(entryWordSpellingLinkage){
    const sourcesLinkages = entryWordSpellingLinkage.querySelectorAll('.js-latin-history-modal');
    sourcesLinkages.forEach(sourcesLinakge => {
      // Reset url fields
      const sourcesUrlsFields = sourcesLinakge.querySelectorAll('.js-source-url-input');
      sourcesUrlsFields.forEach(sourcesUrlField => {
        sourcesUrlField.value = '';
      });

      // Reset page no. fields
      const sourcesPageNoFields = sourcesLinakge.querySelectorAll('.js-source-page-no-input');
      sourcesPageNoFields.forEach(sourcesPageNoField => {
        sourcesPageNoField.value = '';
      });
    });
  }

  resetEnrtyWordSpellingLinkageToggles(entryWordSpellingLinkage, resetNearSynonymToggle = false){
    const relationshipToggles = entryWordSpellingLinkage.querySelectorAll('input[type="checkbox"]');
      
    relationshipToggles.forEach(relationshipToggle => {
      // Preserve the value of the alternative toggle
      if (resetNearSynonymToggle || !relationshipToggle.classList.contains('js-marked-as-near-synonym-toggle')) {
        relationshipToggle.checked = false;
      }
    });
  }

  removePrimaryFlagClassFromPreviousPrimarySpellingLinkages(entryWordSpellingLinkage){
    const currentWordPrimarySpellingContainers = entryWordSpellingLinkage.querySelectorAll('.js-current-word-primary-spelling');

    currentWordPrimarySpellingContainers.forEach(currentWordPrimarySpellingContainer => {
      if (currentWordPrimarySpellingContainer.classList.contains('js-primary-entry-linkage')) {
        currentWordPrimarySpellingContainer.classList.remove('js-primary-entry-linkage');
      }
    });
  }

  addPrimaryFlagClassOnFieldMarkedAsPrimary(fieldMarkedAsPrimaryContainer){
    const currentWordPrimarySpellingContainers = fieldMarkedAsPrimaryContainer.querySelectorAll('.js-current-word-primary-spelling');
    
    currentWordPrimarySpellingContainers.forEach(currentWordPrimarySpellingContainer => {
      currentWordPrimarySpellingContainer.classList.add('js-primary-entry-linkage');
    });
  }

  resetComponentLinkagesHiddenFieldValues(spellingLinkageModal) {
    // Get the container for component spellings linkages
    const componentSpellingsLinkagesContainer = spellingLinkageModal.querySelector('.js-component-spelling-linkages-container');
    if (!componentSpellingsLinkagesContainer) return;

    // Get all component linkage elements inside the container
    const allComponentLinkages = componentSpellingsLinkagesContainer.querySelectorAll('.js-component-spelling-linkage');

    // Loop through each component linkage and reset the values
    allComponentLinkages.forEach(linkage => {
      const spellingRelationshipType = linkage.querySelector('.js-spelling-relationship-type');
      if (spellingRelationshipType) spellingRelationshipType.value = '';

      const explanationSpellingTempId = linkage.querySelector('.js-explanation-spelling-temp-id');
      if (explanationSpellingTempId) explanationSpellingTempId.value = '';

      const hiddenFieldForExplainedSpellingId = linkage.querySelector('.js-hidden-field-for-explained-spelling-id');
      if (hiddenFieldForExplainedSpellingId) hiddenFieldForExplainedSpellingId.value = '';

      const hiddenFieldForExplanationSpellingId = linkage.querySelector('.js-hidden-field-for-explanation-spelling-id');
      if (hiddenFieldForExplanationSpellingId) hiddenFieldForExplanationSpellingId.value = '';
    });
  }

  removeLinkagesOfSpellingUnmarkedAsComponent(linkagesToRemove){
    linkagesToRemove.forEach(linkage => {
      if (linkage.classList.contains('js-component-spelling-linkage-template')) {
        linkage.remove(); // Remove if it's a template
      } else {
        const destroyField = linkage.querySelector('.js-destroy-component-spelling-linkage');
        
        if (destroyField) {
          linkage.classList.add('collapse');
          destroyField.value = "1"; // Mark to destroy
        }
      }
    });
  }

  // The `skipCurrentSpellingContainer` flag is used because this method can be triggered in two scenarios:
  // 1. When the component toggle is turned off.
  // 2. When the component spelling text field is updated.
  // In the second case (when triggered by a spelling update), we don't want to reset the component linkages
  // in the linkage modal, hence we skip the current spelling container.
  resetComponentSpellingModalLinkages(spellingFieldContainer, spellingValue, skipCurrentSpellingContainer) {
    const allSpellings       = [...document.querySelectorAll('.js-entries-input')];

    // Filter component spellings from all spellings
    let componentSpellings   = typeo_form.getComponentSpellings(allSpellings);

    if (!skipCurrentSpellingContainer && !componentSpellings.includes(spellingFieldContainer)) {
      // Include current spelling in componentSpellings because its component toggle was just turned off in the frontend and its modal fields require reset.
      componentSpellings.push(spellingFieldContainer);
    } else if (skipCurrentSpellingContainer && componentSpellings.includes(spellingFieldContainer)) {
      // Exclude current spelling in componentSpellings because its component toggle is not turned and only text field value is updated.
      const currentSpellingContainerIndex = componentSpellings.indexOf(spellingFieldContainer);
      
      if (currentSpellingContainerIndex > -1) {
        componentSpellings.splice(currentSpellingContainerIndex, 1);
      }
    }

    componentSpellings.forEach(spelling => {
      const spellingLinkageModal = spelling.querySelector('.js-spelling-linkage-modal');
      if (spellingLinkageModal) {
        const componentSpellingLinkages = [...spellingLinkageModal.querySelectorAll('.js-component-spelling-linkage:not(.collapse)')];
        
        const linkagesToRemove   = componentSpellingLinkages.filter(linkage => {
          const explanationValue = linkage.querySelector('.js-component-spelling-explanation')?.textContent.trim();
          const explainedValue   = linkage.querySelector('.js-explained-component-spelling')?.textContent.trim();
          return explanationValue === spellingValue || explainedValue === spellingValue;
        }); 

        this.removeLinkagesOfSpellingUnmarkedAsComponent(linkagesToRemove);     
      }
    });
  }

  handleComponentPartToggleStateChange(event){
    const componentToggle = event.target;

    const spellingFieldContainer = componentToggle.closest('.js-entries-input');

    if (spellingFieldContainer) {
      // Find the `.js-entry-words-primary-spellings-icon` inside spellingFieldContainer
      const icon = spellingFieldContainer.querySelector('.js-entry-words-primary-spellings-icon');
      if (icon) {
        if (componentToggle.checked) {
          icon.classList.remove('collapse'); // Show the icon
          // Reset molecule icon colors for all component spellings,
          // as new spelling fields will be added for linking
          typeo_form.resetAllComponentSpellingsMoleculeIconColor();
          typeo_form.updateDestroyValueOFAllEntrySpellingLinkagesOfSelectedContainer(spellingFieldContainer, 'false')
        } else {
          const spellingValue = spellingFieldContainer.querySelector('.js-text-field').value;

          this.resetComponentSpellingModalLinkages(spellingFieldContainer, spellingValue, false)
          icon.classList.add('collapse'); // Hide the icon
        }
          
        typeo_form.handlePrimarySpellingMoleculeIcon(componentToggle.checked);
      }
    }
  }

  handleSpellingsVisibilityInLinkageModal(isComponentChecked) {
    typeo_form.handleMultiAndInPartWordSpellingsVisibiliyInLinkageModal(isComponentChecked);
  }
 
  handleGoButtonActivation(e) {
    // Finding closest input-group and then select its URL field
    const button = e.currentTarget;
    const inputGroup = button.closest('.js-input-group');
    const urlInput = inputGroup.querySelector('.js-source-url-input');

    if (urlInput) {
      const url = urlInput.value.trim();
      if (url) {
        button.href = url;
        button.removeAttribute("disabled");
        window.open(url, "_blank");
      } else {
        button.setAttribute("disabled"); // Disable if no URL
      }
    }
  }

  // Method to move focus to next/previous Latin field
  moveLatinFieldFocus(direction = 1) {
    const latinFields = Array.from(document.querySelectorAll('.js-text-field'))
    .filter(el => el.offsetParent !== null);
    const currentIndex = latinFields.indexOf(document.activeElement);
    if (currentIndex === -1 || latinFields.length === 0) return;
    let nextIndex = (currentIndex + direction + latinFields.length) % latinFields.length;
    latinFields[nextIndex].focus();
  }

  // Method to detect if a value contains variant-generating patterns (dots or dashes)
  hasVariantGeneratingPattern(input) {
    if (!input) {
      return false;
    }
    
    // Check for dots (.) or dashes (-) in the input
    const hasDot  = input.indexOf('.') !== -1;   // indexOf returns -1 if the character is not found
    
    return hasDot;
  }

  updateDerivedToggleVisibility() {
    const isMisspelledChecked = this.hasMisspelledCheckBoxTarget && this.misspelledCheckBoxTarget.checked;
    const targetContainerId = isMisspelledChecked ? 'js-corrected-otto-fields-container' : 'js-primary-otto-fields-container';
    const targetContainer = document.getElementById(targetContainerId);

    if (!targetContainer) return;

    // Get all visible .js-entries-input elements within the target container
    const visibleOttoFields = Array.from(targetContainer.querySelectorAll('.js-entries-input'))
      .filter(el => el.offsetParent !== null && !el.classList.contains('d-none'));

    // Iterate through visible fields and handle derived toggle visibility
    visibleOttoFields.forEach((field, index) => {
      const derivedToggle          = field.querySelector('.js-marked-as-derived-value-toggle:not([class*="js-entry-word-spellings-relationship-toggle"])');
      const derivedToggleContainer = derivedToggle?.closest('.js-marked-as-derived-value-toggle-container');
      
      if (derivedToggle && derivedToggleContainer) {
        if (index === 1) {
          // Show derived toggle on second field (index 1)
          derivedToggleContainer.classList.remove('d-none');
        } else {
          // Hide derived toggle on all other fields
          if (derivedToggle.checked) {
            derivedToggle.checked = false;
            // Fire change so dependencies (e.g., Plural) react properly
            derivedToggle.dispatchEvent(new Event('change', { bubbles: true }));
          }
          derivedToggleContainer.classList.add('d-none');
        }
      }
      // Handle vertical separator visibility for this field
      setTimeout(() => this.updateDerivedToggleVerticalSeparatorVisibility(derivedToggle, derivedToggleContainer, field), 0);
      setTimeout(() => this.updateVerbToggleSeparatorVisibility(), 0);
    });

  }

  // Helper method to update vertical separator visibility
  updateDerivedToggleVerticalSeparatorVisibility(derivedToggle, derivedToggleContainer, field) {
    // const derivedToggleSeparator = field.querySelector('.js-derived-toggle-separator');
    const derivedToggleSeparator = derivedToggle?.closest('.js-otto-toggles-parent-container')?.querySelector('.js-derived-toggle-separator')
    if (!derivedToggleSeparator) return;  

    // Check if derived toggle is visible
    const derivedVisible = derivedToggleContainer && !derivedToggleContainer.classList.contains('d-none');

    // Check if any of the subsequent toggles are visible
    const incorrectToggle = field.querySelector('.js-marked-as-incorrect-toggle');
    const unusedToggle    = field.querySelector('.js-marked-as-unused-toggle');
    const componentToggleContainer = field.querySelector('.js-marked-as-component-toggle-container');

    const incorrectVisible = incorrectToggle && !incorrectToggle.closest('.js-primary-only-toggle').classList.contains('d-none');
    const unusedVisible    = unusedToggle && !unusedToggle.closest('.js-primary-only-toggle').classList.contains('d-none');
    const componentVisible = componentToggleContainer && !componentToggleContainer.classList.contains('d-none');

    // Show separator only if derived toggle is visible AND at least one subsequent toggle is visible
    const hasVisibleSubsequentToggle = incorrectVisible || unusedVisible || componentVisible;

    if (derivedVisible && hasVisibleSubsequentToggle) {
      derivedToggleSeparator.classList.remove('d-none');
    } else {
      derivedToggleSeparator.classList.add('d-none');
    }
  }

  updateVerbToggleSeparatorVisibility() {
    // Get all visible .js-entries-input elements within the target container
    const ottoFields = document.querySelectorAll('.js-entries-input')

    ottoFields.forEach((field, index) => {
      const verbToggleSeparator = field.querySelector('.js-verb-toggle-separator');
      if (!verbToggleSeparator) return;

      // Check if any of the subsequent toggles are visible
      const derivedToggle   = field.querySelector('.js-marked-as-derived-value-toggle:not([class*="js-entry-word-spellings-relationship-toggle"])');
      const incorrectToggle = field.querySelector('.js-marked-as-incorrect-toggle');
      const unusedToggle    = field.querySelector('.js-marked-as-unused-toggle');
      const componentToggleContainer = field.querySelector('.js-marked-as-component-toggle-container');

      const derivedVisible   = derivedToggle && !derivedToggle.closest('.js-marked-as-derived-value-toggle-container').classList.contains('d-none');
      const incorrectVisible = incorrectToggle && !incorrectToggle.closest('.js-primary-only-toggle').classList.contains('d-none');
      const unusedVisible    = unusedToggle && !unusedToggle.closest('.js-primary-only-toggle').classList.contains('d-none');
      const componentVisible = componentToggleContainer && !componentToggleContainer.classList.contains('d-none');

      // Show separator only if at least one subsequent toggle is visible
      const hasVisibleSubsequentToggle = derivedVisible || incorrectVisible || unusedVisible || componentVisible;

      if (hasVisibleSubsequentToggle) {
        verbToggleSeparator.classList.remove('d-none');
      } else {
        verbToggleSeparator.classList.add('d-none');
      }
    });
  }

  updateComponentToggleVisibility() {
    const isMisspelledChecked = this.hasMisspelledCheckBoxTarget && this.misspelledCheckBoxTarget.checked
    const targetContainerId   = isMisspelledChecked ? 'js-corrected-otto-fields-container' : 'js-primary-otto-fields-container';
    const targetContainer     = document.getElementById(targetContainerId);

    if (!targetContainer) return;

    // Get all visible .js-entries-input elements within the target container
    const visibleOttoFields = Array.from(targetContainer.querySelectorAll('.js-entries-input'))
      .filter(el => el.offsetParent !== null && !el.classList.contains('d-none'));

    let primaryFieldIndex = -1;
    let fieldsAfterPrimary = [];

    // Find the primary field and collect fields after it
    visibleOttoFields.forEach((field, index) => {
      const primaryRadioBtn          = field.querySelector('.js-marked-as-primary-radio-btn');
      const componentToggleContainer = field.querySelector('.js-marked-as-component-toggle-container');
      const componentToggle          = componentToggleContainer?.querySelector('.js-marked-as-component-toggle');      

      if (primaryRadioBtn && primaryRadioBtn.checked) {
        primaryFieldIndex = index;
      }
      
      // If we've found the primary field, collect subsequent fields
      if (primaryFieldIndex !== -1 && index > primaryFieldIndex) {
        fieldsAfterPrimary.push(field);
      } else {
        // Handle component toggle visibility
        if (componentToggle) {
            // This field is before or at primary - uncheck and hide
            componentToggle.checked = false;
            componentToggleContainer.classList.add('d-none');
        }
      }
    });

    // Show component toggles only if there are ≥ 2 fields after primary
    if (fieldsAfterPrimary.length >= 2) {
      fieldsAfterPrimary.forEach(field => {
        const componentToggleContainer = field.querySelector('.js-marked-as-component-toggle-container');
        if (componentToggleContainer) {
          componentToggleContainer.classList.remove('d-none');
        }
      });
    } else {
      // If count is less than 2, uncheck and hide component toggles for fields after primary
      fieldsAfterPrimary.forEach(field => {
        const componentToggleContainer = field.querySelector('.js-marked-as-component-toggle-container');
        const componentToggle = componentToggleContainer?.querySelector('.js-marked-as-component-toggle');
        
        if (componentToggle) {
          componentToggle.checked = false;
          componentToggleContainer.classList.add('d-none');
        }
      });
    }
  }

  applyRelatedTogglesExclusivity(e) {
    const currentTarget = e.currentTarget;
    const currentField            = this.getCurrentTypingField(currentTarget);    
    const stronglyRelatedToggle   = this.getCurrentOttoFieldToggle(currentField, 'stronglyRelatedToggle');
    const moderatelyRelatedToggle = this.getCurrentOttoFieldToggle(currentField, 'moderatelyRelatedToggle');
    const weaklyRelatedToggle     = this.getCurrentOttoFieldToggle(currentField, 'weaklyRelatedToggle');

    if (stronglyRelatedToggle.checked || moderatelyRelatedToggle.checked || weaklyRelatedToggle.checked) {
      this.uncheckAllNonRelatedCaegoryToggles(currentField);
    }
  }

  uncheckAllNonRelatedCaegoryToggles(field) {
    const nonRelatedToggleNames = [
      'unrelatedToggle',
      'closeToAccurateToggle',
      'accurateToggle',
      'corruptedToggle',
      'misspelledToggle',
      'misUsedToggle',
      'mispronouncedToggle',
      'moreUsedToggle',
      'vulgarToggle',
      'rootToggle',
      'singularToggle',
      'nearSynonymToggle',
      'synonymToggle',
      'derivedToggle',
      'pluralToggle',
      'oppositeToggle',
      'counterpartToggle',
      'alternateSpellingToggle',
      'commonRootToggle',
      'lessUsedToggle',
      'lessAccurateToggle'
    ];

    nonRelatedToggleNames.forEach(toggleName => {
      const el = this.getCurrentOttoFieldToggle(field, toggleName);
      if (el) el.checked = false;
    });
  }

  uncheckAllRelatedCategoryToggles(e) {
    const currentTarget           = e.currentTarget;
    const currentField            = this.getCurrentTypingField(currentTarget);
    const stronglyRelatedToggle   = this.getCurrentOttoFieldToggle(currentField, 'stronglyRelatedToggle');
    const moderatelyRelatedToggle = this.getCurrentOttoFieldToggle(currentField, 'moderatelyRelatedToggle');
    const weaklyRelatedToggle     = this.getCurrentOttoFieldToggle(currentField, 'weaklyRelatedToggle');

    stronglyRelatedToggle.checked   = false;
    moderatelyRelatedToggle.checked = false;
    weaklyRelatedToggle.checked     = false;    

  }

  keepRequiredLanguageToggleOn(e) {
    const toggle = e.currentTarget;
    if (toggle.checked || !this.requiredLanguageFlags.length) return;

    const languageFlag = this.requiredLanguageFlags.find((flag) => toggle.name?.includes(`[${flag}]`));
    if (!languageFlag) return;

    toggle.checked = true;
    showFlashMessage('This language cannot be removed because it is assigned to at least one of the compound’s components.', 'alert');
  }

  // Shows a user icon under compound language toggles that the user turned on (not from a component).
  syncManualLanguageIndicators(changedToggle = null) {
    const toggleContainer = changedToggle?.closest('.js-otto-spellings-lang-toggles-container');

    // If a toggle just changed, keep this spelling's manual list in sync before updating icon visibility.
    if (changedToggle && toggleContainer) {
      let manuallyActivatedLanguageFlags = JSON.parse(toggleContainer.dataset.manuallyActivatedLanguageFlags || '[]');
      const changedFlag = this.ottomanLanguageFlags.find((flag) => changedToggle.name?.includes(`[${flag}]`));
      const isRequired = this.requiredLanguageFlags.includes(changedFlag);
      if (changedFlag && !isRequired) {
        // User turned it ON → remember as manual.
        if (changedToggle.checked && !manuallyActivatedLanguageFlags.includes(changedFlag)) {
          manuallyActivatedLanguageFlags.push(changedFlag);
        }
        // User turned it OFF → drop from the manual list.
        if (!changedToggle.checked) {
          manuallyActivatedLanguageFlags = manuallyActivatedLanguageFlags.filter((flag) => flag !== changedFlag);
        }
      }
      toggleContainer.dataset.manuallyActivatedLanguageFlags = JSON.stringify(manuallyActivatedLanguageFlags);
    }

    this.element.querySelectorAll('.js-otto-spellings-lang-toggles-container').forEach((container) => {
      const manuallyActivatedLanguageFlags = JSON.parse(container.dataset.manuallyActivatedLanguageFlags || '[]');

      container.querySelectorAll('input.typeo-language-toggle-input').forEach((toggle) => {
        const languageFlag = this.ottomanLanguageFlags.find((flag) => toggle.name?.includes(`[${flag}]`));
        const wrapper = toggle.closest('.d-flex.flex-column');
        if (!languageFlag || !wrapper) return;

        // Icon only when ON, in the manual list, and not required by a component.
        const showIndicator = toggle.checked &&
          manuallyActivatedLanguageFlags.includes(languageFlag) &&
          !this.requiredLanguageFlags.includes(languageFlag);
        const indicator = wrapper.querySelector('.js-manual-language-indicator');
        if (!indicator) return;

        this.updateManualLanguageIndicator(indicator, showIndicator);
      });
    });
  }

  updateManualLanguageIndicator(indicator, show) {
    indicator.classList.toggle('d-none', !show);
  
    if (typeof bootstrap === 'undefined' || !bootstrap.Tooltip) return;
  
    let tooltip = bootstrap.Tooltip.getInstance(indicator);
    if (show) {
      if (!tooltip) tooltip = new bootstrap.Tooltip(indicator);
      tooltip.update();
    } else {
      tooltip?.hide();
    }
  }

  // Language toggle changed → update the manual icon.
  handleManualLanguageToggleChange(event) {
    if (event.target.classList.contains('typeo-language-toggle-input')) {
      this.syncManualLanguageIndicators(event.target);
    }
  }

  handleVerbTurkishDependency(e) {
    const currentTarget         = e.target;
    const currentField          = this.getCurrentTypingField(currentTarget);
    
    const verbToggle            = this.getCurrentOttoFieldToggle(currentField, 'verbToggle');
    const turkishToggle         = this.getCurrentOttoFieldToggle(currentField, 'turkishToggle');
    const turkishByAuthorToggle = this.getCurrentOttoFieldToggle(currentField, 'turkishByAuthorToggle');

    if (!verbToggle) return;

    const turkishActive = ((turkishToggle && turkishToggle.checked) || (turkishByAuthorToggle && turkishByAuthorToggle.checked));
    
    if (currentTarget === verbToggle && verbToggle.checked && !turkishActive) {
      // If Verb turned on but Turkish is off → turn Turkish on
      turkishToggle.checked = true;
    } else if (!turkishActive) {
        // If Turkish is off → Verb cannot remain active
        verbToggle.checked = false;      
    }
  }
}